export default {
  'header.homepage': 'Startseite',
  'header.workspace': 'Arbeitsbereich',
  'login.title': 'AIMATEX',
  'login.welcome': 'Willkommen bei AIMATEX',
  'login.description': 'AIMATEX ist Ihre KI-Assistenten-Plattform. Sichere und bequeme Dienste. Greifen Sie jederzeit und überall auf alle Ihre Dateien zu.',
  'login.email.placeholder': 'E-Mail oder Benutzername',
  'login.password.placeholder': 'Passwort',
  'login.button': 'Anmelden',
  'login.loading': 'Anmeldung läuft...',
  'login.divider': 'oder',
  'login.signup': 'Noch kein Konto?',
  'login.signup.link': 'Jetzt registrieren',
  'login.error.default': 'Anmeldung fehlgeschlagen, bitte versuchen Sie es später erneut',
  'login.success': 'Erfolgreich angemeldet',
  'login.forgotPassword': 'Passwort vergessen?',
  'login.forgotPassword.link': 'Hier zurücksetzen',
  'login.rememberPassword': 'Passwort merken',
  'login.social.comingSoon': 'Diese Anmeldemethode kommt bald',
  'captcha.placeholder': 'Captcha-Code',
  'captcha.refresh': 'Captcha aktualisieren',
  'auth.modal.title': 'Anmeldung erforderlich',
  'auth.modal.content': 'Ihre Sitzung ist abgelaufen oder Sie sind nicht angemeldet. Bitte melden Sie sich an, um fortzufahren.',
  'auth.modal.ok': 'Zur Anmeldung',
  'auth.modal.cancel': 'Später',
  'signup.page.title': 'Registrierung - AIMATEX',
  'signup.title': 'AIMATEX',
  'signup.welcome': 'Willkommen bei AIMATEX',
  'signup.description': 'Erstellen Sie Ihr Konto und starten Sie Ihre KI-Kreativ-Reise',
  'signup.feature.ai': 'KI-Betrieben',
  'signup.feature.video': 'Videoerstellung',
  'signup.feature.fast': 'Schnelle Generierung',
  'signup.feature.creative': 'Unbegrenzte Kreativität',
  'signup.username.placeholder': 'Benutzername eingeben',
  'signup.email.placeholder': 'E-Mail eingeben',
  'signup.password.placeholder': 'Passwort eingeben',
  'signup.confirmPassword.placeholder': 'Passwort bestätigen',
  'signup.inviteCode.placeholder': 'Einladungscode (optional)',
  'signup.button': 'Registrieren',
  'signup.loading': 'Registrierung läuft...',
  'signup.login': 'Bereits ein Konto?',
  'signup.login.link': 'Anmelden',
  'signup.error.passwordMismatch': 'Passwörter stimmen nicht überein',
  'signup.error.default': 'Registrierung fehlgeschlagen, bitte versuchen Sie es später erneut',
  'signup.success': 'Erfolgreich registriert',
  'signup.username.rule.length': 'Benutzername muss zwischen 4 und 10 Zeichen lang sein',
  'signup.username.rule.format': 'Nur Buchstaben, Zahlen, Unterstriche und Bindestriche sind erlaubt',
  'signup.password.rule.length': 'Passwort muss zwischen 6 und 20 Zeichen lang sein',
  'signup.password.rule.lowercase': 'Muss Kleinbuchstaben enthalten',
  'signup.password.rule.uppercase': 'Muss Großbuchstaben enthalten',
  'signup.password.rule.number': 'Muss Zahlen enthalten',
  'signup.password.rule.special': 'Muss Sonderzeichen enthalten',
  'resetPassword.page.title': 'Passwort zurücksetzen - AIMATEX',
  'resetPassword.page.description': 'Setzen Sie Ihr AIMATEX-Kontopasswort zurück',
  'resetPassword.title': 'Passwort zurücksetzen',
  'resetPassword.email.placeholder': 'E-Mail-Adresse eingeben',
  'resetPassword.code.placeholder': 'Bestätigungscode eingeben',
  'resetPassword.password.placeholder': 'Neues Passwort eingeben',
  'resetPassword.button': 'Zurücksetzen',
  'resetPassword.button.loading': 'Wird zurückgesetzt...',
  'resetPassword.backToLogin': 'Zurück zum Login',
  'resetPassword.sendCode': 'Code anfordern',
  'resetPassword.sendCode.sending': 'Wird gesendet...',
  'resetPassword.sendCode.retry': 'In {seconds}s erneut versuchen',
  'resetPassword.error.emailRequired': 'Bitte geben Sie Ihre E-Mail-Adresse ein',
  'resetPassword.error.codeRequired': 'Bitte geben Sie den Bestätigungscode ein',
  'resetPassword.error.passwordRequired': 'Bitte geben Sie ein neues Passwort ein',
  'resetPassword.error.passwordLength': 'Das Passwort muss zwischen 6 und 20 Zeichen lang sein',
  'resetPassword.error.codeLength': 'Der Bestätigungscode muss 6 Ziffern enthalten',
  'resetPassword.success.codeSent': 'Bestätigungscode wurde an Ihre E-Mail gesendet',
  'resetPassword.success.reset': 'Passwort erfolgreich zurückgesetzt',
  'resetPassword.error.sendFailed': 'Fehler beim Senden des Bestätigungscodes, bitte versuchen Sie es später erneut',
  'resetPassword.error.resetFailed': 'Fehler beim Zurücksetzen des Passworts, bitte versuchen Sie es später erneut',
  'resetPassword.error.incomplete': 'Bitte füllen Sie alle erforderlichen Felder aus',
  'resetPassword.subtitle': 'Geben Sie Ihre E-Mail-Adresse und ein neues Passwort ein, um den Zugang zu Ihrem Konto zurückzusetzen.',
  'resetPassword.email.label': 'E-Mail',
  'resetPassword.code.label': 'Bestätigungscode',
  'resetPassword.password.label': 'Neues Passwort',
  'resetPassword.success.title': 'Zurücksetzen erfolgreich',
  'resetPassword.success.description': 'Ihr Passwort wurde erfolgreich aktualisiert. Sie können sich jetzt mit Ihrem neuen Passwort anmelden.',
  'resetPassword.goToLogin': 'Zum Login',
  'resetPassword.promo.title': 'Schützen Sie Ihr Konto, bewahren Sie Ihre Kreativität.',
  'resetPassword.promo.description': 'Wir setzen Sicherheitsprotokolle auf Bankniveau ein, um sicherzustellen, dass Ihre Daten und Kreationen ausschließlich Ihnen gehören.',
  'signup.verificationCode.placeholder': 'Bestätigungscode eingeben',
  'signup.verificationCode.send': 'Code abrufen',
  'signup.verificationCode.sending': 'Wird gesendet...',
  'signup.verificationCode.retry': 'In {seconds}s erneut versuchen',
  'signup.verificationCode.success': 'Bestätigungscode gesendet',
  'signup.verificationCode.error': 'Fehler beim Senden des Codes',
  'signup.verificationCode.required': 'Bitte Bestätigungscode eingeben',
  'signup.verificationCode.invalid': 'Ungültiges Verifizierungscode-Format',
  'signup.error.emailRequired': 'Bitte geben Sie Ihre E-Mail-Adresse ein',
  'signup.announcement': 'Die Registrierungsfunktion wird heute gewartet!',
  'sidebar.create': 'Erstellen',
  'sidebar.allFiles': 'Alle Dateien',
  'sidebar.starred': 'Favoriten',
  'sidebar.folders': 'Ordner',
  'sidebar.trash': 'Papierkorb',
  'sidebar.decrypt': 'Entschlüsselungstool',
  'sidebar.promptMarket': 'Prompt Market',
  'sidebar.channels': 'Kanäle',
  'sidebar.dailyChallenge': 'Tägliche Herausforderung',
  'sidebar.mediaTools': 'Medientools',
  'sidebar.storageNodes': 'Speicherknoten',
  'create.tab.textToImage': 'Text zu Bild',
  'create.tab.textToVideo': 'Text zu Video',
  'create.tab.imageToImage': 'Bild zu Bild',
  'create.tab.imageToVideo': 'Bild zu Video',
  'create.tab.seedanceVideo': 'Seedance Bild zu Video',
  'create.seedance.title': 'Seedance Bild zu Video',
  'create.seedance.subtitle': 'ByteDance Doubao Seedance 1.5, bildgesteuerte Kurzvideo-Erstellung',
  'create.seedance.noModel': 'Kein Seedance-Modell verfügbar. Bitte in der Verwaltung konfigurieren.',
  'create.seedance.cameraFixed': 'Kamera fixiert',
  'create.seedance.cameraFixed.true': 'Ja (fixiert)',
  'create.seedance.cameraFixed.false': 'Nein (dynamisch)',
  'create.seedance.watermark': 'Wasserzeichen hinzufügen',
  'create.seedance.watermark.true': 'Ja',
  'create.seedance.watermark.false': 'Nein',
  'create.textToImage.title': 'Text zu Bild',
  'create.textToImage.subtitle': 'Geben Sie eine Beschreibung ein und lassen Sie KI das Bild in Ihrem Kopf zeichnen',
  'create.textToImage.description': 'Generieren Sie Bilder aus Textbeschreibungen. Diese Funktion wird entwickelt...',
  'create.textToVideo.title': 'Text zu Video',
  'create.textToVideo.subtitle': 'Geben Sie Szenenbeschreibungen und Kamerasteuerungen ein, um hochwertige Videos zu generieren',
  'create.textToVideo.description': 'Generieren Sie Videos aus Textbeschreibungen. Diese Funktion wird entwickelt...',
  'create.imageToImage.title': 'Bild zu Bild',
  'create.imageToImage.description': 'Generieren Sie neue Bilder aus Referenzbildern. Diese Funktion wird entwickelt...',
  'create.imageToVideo.title': 'Bild zu Video',
  'create.imageToVideo.description': 'Generieren Sie Videos aus Referenzbildern. Diese Funktion wird entwickelt...',
  'sidebar.feedback': 'Feedback',
  'sidebar.about': 'Über',
  'sidebar.productLog': 'Produktaktualisierungen',
  'promptMarket.title': 'Prompt Market',
  'promptMarket.subtitle': 'Entdecken Sie KI-Inspirationen von Top-Kreativen und entfalten Sie Ihr kreatives Potenzial',
  'promptMarket.searchPlaceholder': 'Prompts, Stile, Modelle suchen...',
  'promptMarket.search': 'Suchen',
  'promptMarket.all': 'Alle',
  'promptMarket.tabAll': 'Empfohlen',
  'promptMarket.tabImage': 'Text zu Bild',
  'promptMarket.tabVideo': 'Text zu Video',
  'promptMarket.tabAudio': 'Text zu Musik',
  'promptMarket.sortLatest': 'Neueste',
  'promptMarket.sortHot': 'Beliebt',
  'promptMarket.sortSales': 'Bestseller',
  'promptMarket.publish': 'Veröffentlichen',
  'promptMarket.empty': 'Noch keine Einträge. Seien Sie der Erste!',
  'promptMarket.free': 'Kostenlos',
  'promptMarket.token': 'TOKEN',
  'promptMarket.loadFailed': 'Laden fehlgeschlagen',
  'promptMarket.listSuccess': 'Erfolgreich veröffentlicht',
  'promptMarket.listFailed': 'Veröffentlichung fehlgeschlagen',
  'market.label': 'PROMPT-MARKT',
  'market.h1': 'Entfesseln Sie Ihre',
  'market.h1.highlight': 'kreative Intelligenz.',
  'market.sub': 'Die Premium-Plattform für KI-Prompts: Bild, Video und Musik. Verifizierte Rezepte für OpenAI, Google, Midjourney, Runway, Kling, Luma, Suno, ElevenLabs und mehr. Schluss mit Raten – einfach erstellen.',
  'market.providers.title': 'Kompatibel mit führenden Modellen und Plattformen',
  'market.card1.title': 'Sofortige Integration',
  'market.card1.desc': 'Überspringen Sie die Lernkurve im Prompt Engineering. Importieren Sie bewährte Prompts mit einem Klick in Ihren Workflow.',
  'market.card2.title': 'Kreativität monetarisieren',
  'market.card2.desc': 'Verwandeln Sie Ihre besten Prompts in passives Einkommen. Schließen Sie sich Tausenden von Kreativen an, die mit ihrer KI-Expertise verdienen.',
  'market.card3.title': 'Geprüfte Qualität',
  'market.card3.desc': 'Jedes Listing wird manuell geprüft und getestet. Wir garantieren konsistente Ergebnisse über verschiedene Modelle.',
  'market.card4.title': 'Das Labor erkunden',
  'market.card4.desc': 'Entdecken Sie über 10.000 von der Community generierte Assets.',
  'market.cta': 'Prompt-Markt starten',
  'home.mediaTools.title': 'Medientools',
  'home.mediaTools.subtitle': 'Online nutzbar, keine Installation. Verarbeiten Sie einfach Bilder, Video und Audio.',
  'home.mediaTools.toolSuffix': '',
  'home.mediaTools.imageCompress.title': 'Bildkomprimierung',
  'home.mediaTools.imageCompress.description': 'Intelligente Komprimierung bei erhaltener Qualität. Stapelverarbeitung.',
  'home.mediaTools.videoCompress.title': 'Videokomprimierung',
  'home.mediaTools.videoCompress.description': 'Effiziente Komprimierung mit Auflösung und Bitrate. Mehrere Formate.',
  'home.mediaTools.audioCompress.title': 'Audiokomprimierung',
  'home.mediaTools.audioCompress.description': 'Dateigröße optimieren, Klarheit behalten. MP3, AAC und mehr.',
  'filelist.column.name': 'Name',
  'filelist.column.size': 'Größe',
  'filelist.column.updateTime': 'Geändert',
  'filelist.column.recycletime': 'Gelöscht am',
  'filelist.column.actions': 'Aktionen',
  'filelist.total': 'Insgesamt {total} Elemente',
  'filelist.action.upload': 'Hochladen',
  'filelist.action.newFolder': 'Neuer Ordner',
  'filelist.action.refresh': 'Aktualisieren',
  'filelist.action.search': 'Dateien suchen',
  'filelist.action.batchDownload': 'Herunterladen',
  'filelist.action.batchDelete': 'Löschen',
  'filelist.action.download': 'Herunterladen',
  'filelist.action.preview': 'Vorschau',
  'filelist.action.rename': 'Umbenennen',
  'filelist.selected': '{count} ausgewählt',
  'page.cloudDrive.title': 'Mein Cloud-Laufwerk',
  'page.cloudDrive.description': 'AIMATEX Cloud-Laufwerk - Speichern und verwalten Sie Ihre Dateien sicher',
  'modal.fileUpload.title': 'Dateien hochladen',
  'modal.fileUpload.dragText': 'Dateien hierher ziehen oder klicken zum Hochladen',
  'modal.fileUpload.start': 'Upload starten',
  'modal.fileUpload.cancel': 'Abbrechen',
  'modal.fileUpload.clear': 'Liste leeren',
  'modal.fileUpload.encrypt': 'Ausgewählte verschlüsseln',
  'modal.fileUpload.addMore': 'Hinzufügen',
  'modal.fileUpload.remove': 'Entfernen',
  'modal.fileUpload.error.noSelection': 'Bitte wählen Sie Dateien zum Entfernen aus',
  'modal.fileUpload.error.noEncryption': 'Bitte wählen Sie Dateien zum Verschlüsseln aus',
  'modal.fileUpload.error.noClear': 'Keine Dateien zum Löschen',
  'modal.fileUpload.error.noStart': 'Keine Dateien zum Hochladen',
  'modal.fileUpload.error.noCancel': 'Kein laufender Upload zum Abbrechen',
  'modal.fileUpload.error.fileSize': 'Dateigröße überschreitet das Limit',
  'modal.fileUpload.error.fileType': 'Nicht unterstützter Dateityp',
  'modal.fileUpload.error.maxCount': 'Maximale Dateianzahl überschritten',
  'modal.fileUpload.duplicate.title': 'Datei existiert bereits',
  'modal.fileUpload.duplicate.skip': 'Überspringen',
  'modal.fileUpload.duplicate.replace': 'Ersetzen',
  'modal.fileUpload.duplicate.rename': 'Umbenennen',
  'modal.fileUpload.status.pending': 'Ausstehend',
  'modal.fileUpload.status.uploading': 'Wird hochgeladen',
  'modal.fileUpload.status.success': 'Abgeschlossen',
  'modal.fileUpload.status.error': 'Fehler',
  'modal.fileUpload.status.cancelled': 'Abgebrochen',
  'modal.fileUpload.status.duplicated': 'Dupliziert',
  'modal.fileUpload.table.filename': 'Dateiname',
  'modal.fileUpload.table.size': 'Größe',
  'modal.fileUpload.table.status': 'Status',
  'modal.fileUpload.table.progress': 'Fortschritt',
  'modal.fileUpload.table.actions': 'Aktionen',
  'modal.fileUpload.speed': 'Upload-Geschwindigkeit',
  'modal.fileUpload.remainingTime': 'Verbleibende Zeit',
  'modal.fileUpload.total.progress': 'Gesamtfortschritt',
  'modal.fileUpload.error.message': 'Upload fehlgeschlagen: {message}',
  'modal.fileUpload.confirm.clear': 'Möchten Sie die Upload-Liste leeren?',
  'modal.fileUpload.confirm.cancel': 'Möchten Sie den Upload abbrechen?',
  'modal.fileUpload.clear.mobile': 'Leeren',
  'modal.fileUpload.encrypt.mobile': 'Verschlüsseln',
  'modal.fileUpload.addMore.mobile': 'Hinzufügen',
  'productLog.title': 'Produktaktualisierungen',
  // Sicherheitsfunktionen
  'security.features.title': 'Sicherheitsfunktionen',
  'security.features.localDecryption.title': 'Lokale Entschlüsselung',
  'security.features.localDecryption.description': 'Alle Entschlüsselungsvorgänge werden lokal im Browser durchgeführt, Dateiinhalte und Passwörter verlassen nie Ihr Gerät',
  'security.features.militaryEncryption.title': 'Militärische Verschlüsselung',
  'security.features.militaryEncryption.description': 'Verwendet AES-256-CBC Verschlüsselungsalgorithmus, den sichersten symmetrischen Verschlüsselungsstandard gegen alle bekannten Angriffe',
  'security.features.privacyProtection.title': 'Datenschutz',
  'security.features.privacyProtection.description': 'Strenger Datenschutzmechanismus, keine Speicherung von Entschlüsselungspasswörtern, keine Aufzeichnung von Dateiinhalten',
  'security.features.smartDecryption.title': 'Smart-Chunk-Entschlüsselung',
  'security.features.smartDecryption.description': 'Smart-Chunk-Entschlüsselungstechnologie verbessert die Entschlüsselungsgeschwindigkeit bei reduziertem Speicherverbrauch',
  'security.features.learnMore': 'Mehr erfahren',
  'security.features.modal.title': 'Sicherheitsfunktionen Details',
  'security.features.modal.close': 'Schließen',
  // Sicherheitshinweise Modal
  'decrypt.security.modal.title': 'Sicherheitshinweis',
  'decrypt.security.modal.description': 'Alle Entschlüsselungsvorgänge werden lokal durchgeführt, Ihr Passwort und Dateiinhalt werden nicht an Server übertragen',
  'decrypt.security.modal.vip.title': 'Als VIP-Benutzer können Sie:',
  'decrypt.security.modal.vip.feature1': 'Dateien beliebiger Größe entschlüsseln',
  'decrypt.security.modal.vip.feature2': 'Smart-Chunk-Entschlüsselung für bessere Effizienz nutzen',
  'decrypt.security.modal.vip.feature3': 'Große Dateien im Batch entschlüsseln',
  'decrypt.security.modal.free.title': 'Wichtig: Der Entschlüsselungsprozess benötigt etwa das 3-fache der Dateigröße an Browser-Speicher.',
  'decrypt.security.modal.free.feature1': 'Kostenlose Nutzer sind auf 4GB pro Datei beschränkt',
  'decrypt.security.modal.free.feature2': 'Upgrade auf VIP für unbegrenzte Dateigröße',
  'decrypt.security.modal.free.feature3': 'Bei Browser-Abstürzen erwägen Sie ein Upgrade für Chunk-Entschlüsselung',
  // CBC-Verschlüsselungsdiagramm
  'security.diagram.plaintext.block1': 'Klartext Block 1',
  'security.diagram.plaintext.block2': 'Klartext Block 2',
  'security.diagram.ciphertext.block1': 'Chiffretext Block 1',
  'security.diagram.ciphertext.block2': 'Chiffretext Block 2',
  'security.diagram.key': 'Schlüssel',
  'security.diagram.aes.encryption': 'AES Verschlüsselung',
  'security.diagram.xor.operation': 'XOR Operation',
  'security.diagram.iv': 'Initialisierungsvektor',
  // Smart Chunk Decryption
  'security.features.chunk.title': 'Intelligente Block-Entschlüsselungstechnologie',
  'security.features.chunk.what': 'Was ist Intelligente Block-Entschlüsselung?',
  'security.features.chunk.description': 'Die intelligente Block-Entschlüsselung ist eine optimierte Technologie für große Dateien, die Dateien in mehrere Blöcke für parallele Verarbeitung aufteilt, mit folgenden Merkmalen:',
  'security.features.chunk.feature1.title': 'Dynamische Aufteilung',
  'security.features.chunk.feature1.desc': 'Passt die Blockgröße automatisch basierend auf Dateigröße und Systemspeicher an',
  'security.features.chunk.feature2.title': 'Parallele Verarbeitung',
  'security.features.chunk.feature2.desc': 'Mehrere Datenblöcke werden gleichzeitig entschlüsselt, nutzt Mehrkern-CPUs voll aus',
  'security.features.chunk.feature3.title': 'Speicheroptimierung',
  'security.features.chunk.feature3.desc': 'Steuert die Speichernutzung durch Streaming-Verarbeitung, um Überlauf zu verhindern',
  'security.features.chunk.feature4.title': 'Wiederaufnahme-Unterstützung',
  'security.features.chunk.feature4.desc': 'Unterstützt Fortsetzung nach Unterbrechung, verbessert die Fehlertoleranz',
  'security.features.chunk.how': 'Funktionsweise',
  'security.features.chunk.process': 'Der intelligente Block-Entschlüsselungsprozess umfasst folgende Schritte:',
  'security.features.chunk.step1': 'Dateianalyse: Berechnet optimale Blockgröße und -anzahl',
  'security.features.chunk.step2': 'Datenaufteilung: Teilt verschlüsselte Datei in gleich große Blöcke',
  'security.features.chunk.step3': 'Parallele Entschlüsselung: Mehrere Blöcke werden gleichzeitig entschlüsselt',
  'security.features.chunk.step4': 'Stream-Schreiben: Entschlüsselte Blöcke werden sequentiell geschrieben',
  'security.features.chunk.code': '{code}',
  'security.features.chunk.performance': 'Leistungsvorteile',
  'security.features.chunk.performance.intro': 'Im Vergleich zur traditionellen Entschlüsselung bietet die intelligente Block-Entschlüsselung signifikante Vorteile:',
  'security.features.chunk.performance.point1': 'Speichernutzung um bis zu 90% reduziert, nur 400MB für 4GB-Datei benötigt',
  'security.features.chunk.performance.point2': '3-5-mal schnellere Entschlüsselungsgeschwindigkeit, nutzt Mehrkern-CPUs',
  'security.features.chunk.performance.point3': 'Unterstützt Entschlüsselung großer Dateien (>4GB), nicht durch Browser-Speicher begrenzt',
  'security.features.chunk.performance.point4': 'Visueller Entschlüsselungsprozess mit genauem Fortschritt und Restzeit',
  'security.features.chunk.usage': 'Anwendungsfälle',
  'security.features.chunk.usage.intro': 'Die intelligente Block-Entschlüsselung ist besonders geeignet für folgende Szenarien:',
  'security.features.chunk.usage.point1': 'Entschlüsselung großer Dateien (z.B. Videos, Datenbank-Backups)',
  'security.features.chunk.usage.point2': 'Entschlüsselungsoperationen auf Geräten mit begrenztem Speicher',
  'security.features.chunk.usage.point3': 'Batch-Entschlüsselung, die parallele Verarbeitung erfordert',
  'security.features.chunk.usage.point4': 'Entschlüsselungsaufgaben, die Echtzeit-Feedback erfordern',
  'security.features.chunk.diagram': 'Diagramm des Block-Entschlüsselungsprozesses',
  'security.features.aes.security': 'Sicherheitseigenschaften',
  'security.features.aes.security.intro': 'AES-256-CBC bietet mehrere Sicherheitsgarantien:',
  'security.features.aes.security.point1': '256-Bit-Schlüssel bietet 2^256 mögliche Kombinationen, unmöglich durch Brute-Force zu knacken, selbst mit einem Supercomputer',
  'security.features.aes.security.point2': 'CBC-Modus stellt sicher, dass identische Klartextblöcke unterschiedliche verschlüsselte Blöcke erzeugen und erhöht die Verschlüsselungsrandomisierung',
  'security.features.aes.security.point3': 'Die Verwendung des Initialisierungsvektors (IV) stellt sicher, dass selbst mit demselben Schlüssel jede Verschlüsselung ein anderes Ergebnis liefert',
  'security.features.aes.security.point4': 'Wird weithin in militärischen, finanziellen und anderen Bereichen mit hohen Sicherheitsanforderungen eingesetzt',
  'security.features.aes.diagram': 'Dynamisches Diagramm des CBC-Modus-Verschlüsselungsprozesses',
  'security.features.aes.why': 'Warum AES-256-CBC?',
  'security.features.aes.why.intro': 'Wir haben AES-256-CBC aus folgenden Gründen als Verschlüsselungsstandard gewählt:',
  'security.features.aes.why.point1': 'Umfassend validierte Sicherheit, keine praktischen Angriffsmethoden bis heute',
  'security.features.aes.why.point2': 'Ausgezeichnete Leistung, schnelle Ver- und Entschlüsselung',
  'security.features.aes.why.point3': 'Hardware-Beschleunigungsunterstützung, AES-Befehlssatz in modernen Prozessoren integriert',
  'security.features.aes.why.point4': 'Breite Werkzeugunterstützung, ausgereifte Implementierungen in allen Programmiersprachen',
  'security.features.aes.what': 'Was ist AES-256-CBC?',
  'security.features.aes.description': 'AES-256-CBC ist eine Implementierung des Advanced Encryption Standard, wobei:',
  'security.features.aes.detail.1': 'Ein symmetrischer Verschlüsselungsalgorithmus, der 2001 vom US National Institute of Standards and Technology (NIST) etabliert wurde',
  'security.features.aes.detail.2': 'Verwendet eine 256-Bit-Schlüssellänge und bietet höchste Sicherheitsstufe',
  'security.features.aes.detail.3': 'Cipher Block Chaining (CBC) Modus bietet verbesserte Verschlüsselungssicherheit',
  'security.features.aes.how': 'Funktionsweise',
  'security.features.aes.process': 'Der AES-256-CBC Verschlüsselungsprozess umfasst folgende Schritte:',
  'security.features.aes.step1': 'Aufteilung der Klartextdaten in Blöcke fester Größe (128 Bit)',
  'security.features.aes.step2': 'Generierung eines zufälligen Initialisierungsvektors (IV)',
  'security.features.aes.step3': 'XOR-Operation zwischen vorherigem Chiffretext-Block und aktuellem Klartext-Block im CBC-Modus',
  'security.features.aes.step4': 'Verwendung des 256-Bit-Schlüssels zur AES-Verschlüsselung des XOR-Ergebnisses',
  'security.features.aes.example': 'Beispiel des Verschlüsselungsprozesses:',
  // FileList Section
  'decrypt.fileList.column.name': 'Dateiname',
  'decrypt.fileList.column.status': 'Status',
  'decrypt.fileList.column.actions': 'Aktionen',
  'decrypt.fileList.status.pending': 'Ausstehend',
  'decrypt.fileList.status.decrypting': 'Entschlüsseln',
  'decrypt.fileList.status.success': 'Abgeschlossen',
  'decrypt.fileList.status.error': 'Fehler',
  'decrypt.fileList.action.info': 'Information',
  'decrypt.fileList.empty': 'Keine Dateien zum Entschlüsseln',
  'common.unknown': 'Unbekannt',
  'common.philosophy': 'Technologie sollte dem Volk dienen',
  'common.speed': 'Geschwindigkeit',
  'common.timeSpent': 'Verstrichene Zeit',
  'common.remaining': 'Verbleibend',
  // Upload Section
  'decrypt.upload.dragText': 'Dateien hier klicken oder ziehen',
  'decrypt.upload.hint': 'Unterstützt Stapelhinzufügung von .encrypted Dateien, maximal {maxSize} pro Datei',
  'decrypt.upload.button.decrypt': 'Ausgewählte Dateien entschlüsseln',
  'decrypt.upload.button.clear': 'Liste leeren',
  'page.decrypt.title': 'Entschlüsselungswerkzeug',
  'page.decrypt.subtitle': 'Entschlüsseln Sie Ihre Dateien sicher und schnell',
  // File Info Modal
  'decrypt.fileInfo.modal.title': 'Dateiinformationen',
  'decrypt.fileInfo.modal.close': 'Schließen',
  'decrypt.fileInfo.name': 'Dateiname',
  'decrypt.fileInfo.size': 'Dateigröße',
  'decrypt.fileInfo.type': 'Dateityp',
  'decrypt.fileInfo.lastModified': 'Zuletzt geändert',
  'decrypt.fileInfo.status': 'Status',
  'decrypt.fileInfo.progress': 'Fortschritt',
  'decrypt.fileInfo.speed': 'Geschwindigkeit',
  'decrypt.fileInfo.timeRemaining': 'Verbleibende Zeit',
  'decrypt.fileInfo.timeSpent': 'Verstrichene Zeit',
  'decrypt.fileInfo.error': 'Fehlermeldung',
  'filelist.modal.rename.title': 'Umbenennen',
  'filelist.modal.rename.placeholder': 'Neuen Namen eingeben',
  'filelist.modal.rename.ok': 'OK',
  'filelist.modal.rename.cancel': 'Abbrechen',
  'sideMenu.storageInfo.title': 'Speicherplatz',
  'sideMenu.storageInfo.usage': 'Verwendet {used} / Gesamt {total}',
  'sideMenu.storageStats.title': 'Speicherstatistik',
  'sideMenu.storageStats.overview': 'Übersicht',
  'sideMenu.storageStats.totalFiles': 'Gesamtanzahl Dateien',
  'sideMenu.storageStats.totalSize': 'Gesamtgröße',
  'sideMenu.storageStats.fileTypes': 'Dateitypenverteilung',
  'sideMenu.storageStats.providers': 'Dienstanbieter',
  'common.default': 'Standard',
  'common.regionCode': 'Regionscode',
  'common.nodeType': 'Knotentyp',
  'common.storageUsed': 'Belegter Speicher',
  'common.storageAvailable': 'Verfügbarer Speicher',
  'common.storageLimit': 'Gesamtkapazität',
  'common.storageUsageDetail': 'Belegt {used} / Gesamt {total}',
  'common.defaultNode': 'Standardknoten',
  'common.confirm': 'Bestätigen',
  'common.cancel': 'Abbrechen',
  'common.latency': 'Latenz',
  'common.retry': 'Wiederholen',
  'cloudDrive.nodeSelect.title': 'Speicherknoten auswählen',
  'cloudDrive.nodeSelect.addNode': 'Speicherknoten hinzufügen',
  'cloudDrive.nodeSelect.deleteConfirm.title': 'Löschung des Knotens bestätigen',
  'cloudDrive.nodeSelect.deleteConfirm.content': 'Möchten Sie den Knoten "{nodeName}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden!',
  'cloudDrive.nodeSelect.deleteSuccess': 'Knoten erfolgreich gelöscht',
  'cloudDrive.nodeSelect.deleteFailed': 'Fehler beim Löschen des Knotens',
  
  // Knoten erstellen
  'cloudDrive.nodeCreate.title': 'Speicherknoten hinzufügen',
  'cloudDrive.nodeCreate.selectProvider': 'Cloud-Anbieter auswählen',
  'cloudDrive.nodeCreate.nodeName': 'Knotenname',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': 'Leer lassen, um Standardnamen zu verwenden',
  'cloudDrive.nodeCreate.nameMaxLength': 'Knotenname darf 50 Zeichen nicht überschreiten',
  'cloudDrive.nodeCreate.noProviders': 'Keine Cloud-Anbieter verfügbar',
  'cloudDrive.nodeCreate.pingLatency': 'Latenz {value} ms',
  'cloudDrive.nodeCreate.pingTesting': 'Latenz wird getestet...',
  'cloudDrive.nodeCreate.pingFailed': 'Latenztest fehlgeschlagen',
  'cloudDrive.nodeCreate.pingUnavailable': 'Latenztest nicht verfügbar',
  'cloudDrive.nodeCreate.sortByLatency': 'Nach Latenz sortieren',
  'cloudDrive.nodeCreate.selectRegion': 'Region auswählen',
  'cloudDrive.nodeCreate.selectedRegion': 'Ausgewählte Region',
  'cloudDrive.nodeCreate.noRegions': 'Keine Regionen verfügbar',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': 'Bitte wählen Sie einen Cloud-Anbieter',
  'cloudDrive.nodeCreate.selectProviderRequired': 'Bitte wählen Sie zuerst einen Cloud-Anbieter',
  'cloudDrive.nodeCreate.selectRegionRequired': 'Bitte wählen Sie zuerst eine Region',
  'cloudDrive.nodeCreate.loadProvidersFailed': 'Fehler beim Laden der Cloud-Anbieter-Liste',
  'cloudDrive.nodeCreate.loadRegionsFailed': 'Fehler beim Laden der Regionsliste',
  'cloudDrive.nodeCreate.nodeType': 'Knotentyp',
  'cloudDrive.nodeCreate.nodeType.standard': 'Standard-Speicher',
  'cloudDrive.nodeCreate.nodeType.lowFreq': 'Niedrigfrequenz-Speicher',
  'cloudDrive.nodeCreate.nodeType.archive': 'Archiv-Speicher',
  'cloudDrive.nodeCreate.storageLimit': 'Speicherlimit',
  'cloudDrive.nodeCreate.storageLimitRequired': 'Bitte geben Sie das Speicherlimit ein',
  'cloudDrive.nodeCreate.storageLimitMin': 'Das Speicherlimit darf nicht kleiner als 1GB sein',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': 'Geben Sie das Speicherlimit ein (GB)',
  'cloudDrive.nodeCreate.success': 'Speicherknoten erfolgreich erstellt',
  'cloudDrive.nodeCreate.failed': 'Fehler beim Erstellen des Speicherknotens',
  
  // Knoten bearbeiten
  'cloudDrive.nodeEdit.title': 'Knoten bearbeiten',
  'cloudDrive.nodeEdit.name': 'Knotenname',
  'cloudDrive.nodeEdit.nameRequired': 'Bitte Knotennamen eingeben',
  'cloudDrive.nodeEdit.nameMaxLength': 'Knotenname darf 50 Zeichen nicht überschreiten',
  
  // TextToImage page internationalization
  'create.prompt': 'Eingabeaufforderung',
  'create.prompt.placeholder': 'z.B.: eine Cyberpunk-Katze, die im Weltraum läuft, Neon-Hintergrund, hohe Details...',
  'create.prompt.required': 'Bitte geben Sie eine Eingabeaufforderung ein',
  'create.prompt.generate': 'KI Eingabeaufforderung generieren',
  'create.prompt.enrich': 'KI Eingabeaufforderung anreichern',
  'create.prompt.generate.success': 'Eingabeaufforderung erfolgreich generiert!',
  'create.prompt.generate.error': 'Fehler beim Generieren der Eingabeaufforderung, bitte versuchen Sie es erneut',
  'create.prompt.generate.empty': 'Keine Eingabeaufforderung generiert, bitte versuchen Sie es erneut',
  'create.prompt.restore': 'Wiederherstellen',
  'create.prompt.restore.success': 'Zur ursprünglichen Eingabeaufforderung wiederhergestellt',
  'create.prompt.restore.tooltip': 'Zur Eingabeaufforderung vor der KI-Generierung/Anreicherung wiederherstellen',
  'create.negativePrompt': 'Negative Eingabeaufforderung',
  'create.ratio': 'Seitenverhältnis',
  'create.style': 'Kunststil',
  'create.batchSize': 'Stapelgröße',
  'create.generate': 'Jetzt generieren',
  'create.negativePrompt.tooltip': 'Elemente, die Sie nicht im Bild haben möchten',
  'create.negativePrompt.placeholder': 'z.B.: unscharf, niedrige Qualität, deformierte Finger...',
  'create.generating': 'Wird generiert...',
  'create.generating.waiting': 'KI erstellt, bitte warten...',
  'create.result.title': 'Generierte Ergebnisse',
  'create.downloadAll': 'Alle herunterladen',
  'create.aspectRatio.1:1': '1:1 (Quadrat)',
  'create.aspectRatio.16:9': '16:9 (Querformat)',
  'create.aspectRatio.9:16': '9:16 (Hochformat)',
  'create.aspectRatio.21:9': '21:9 (Kino)',
  'create.aspectRatio.4:3': '4:3 (Klassisch)',
  'create.style.general': 'Allgemein',
  'create.style.anime': 'Anime',
  'create.style.realistic': 'Realistisch',
  'create.style.3d-render': '3D Render',
  'create.style.cyberpunk': 'Cyberpunk',
  'create.settings.loadFailed': 'Fehler beim Laden der Erstellungstyp-Einstellungen, alle Optionen werden angezeigt',
  'create.settings.error': 'Fehler beim Laden der Einstellungen, alle Optionen werden angezeigt',
  'create.noAvailableTabs': 'Keine verfügbaren Erstellungstypen',
  'create.network.error.title': 'Netzwerkverbindungsfehler',
  'create.network.error.description': 'Erstellungstyp-Einstellungen konnten nicht geladen werden. Bitte überprüfen Sie Ihre Netzwerkverbindung und aktualisieren Sie die Seite',
  'create.network.error.refresh': 'Seite aktualisieren',
  
  // TextToVideo page internationalization
  'create.prompt.video': 'Video-Szenenbeschreibung (Prompt)',
  'create.prompt.video.placeholder': 'z.B., Ein Astronautenhund, der auf der Mondoberfläche tanzt, 8K, filmische Beleuchtung, Surrealismus.',
  'create.prompt.video.required': 'Bitte geben Sie eine Video-Szenenbeschreibung ein',
  'create.generate.video': 'Video jetzt generieren',
  'create.video.ratio': 'Video-Seitenverhältnis',
  'create.video.camera': 'Kamerabewegung',
  'create.video.duration': 'Videodauer (Sekunden)',
  'create.video.format': 'Ausgabeformat',
  'create.cameraMotion.none': 'Keine Bewegung (None)',
  'create.cameraMotion.zoomIn': 'Heranzoomen (Zoom In)',
  'create.cameraMotion.dollyOut': 'Herausfahren (Dolly Out)',
  'create.cameraMotion.panLeft': 'Nach links schwenken (Pan Left)',
  'create.cameraMotion.tiltUp': 'Nach oben neigen (Tilt Up)',
  'create.cameraMotion.orbital': '360° Orbital',
  'create.negativePrompt.video.placeholder': 'z.B., Wasserzeichen, Flackern, niedrige Auflösung, unscharfe Charaktere...',
  'create.sora.thinking': 'Sora denkt nach...',
  'create.video.analyzing': 'Analysiere Bild und Prompt, KI erstellt...',
  'create.video.info': 'Dauer: {duration}s | Verhältnis: {ratio}',
  'create.video.preview': 'Video-Vorschau',
  'create.video.result': 'Finale Video-Vorschau',
  'create.video.empty': 'Generierte Ergebnisse werden hier angezeigt',
  'create.download': 'Video herunterladen',
  'create.duration.format': '{duration}s',
  'create.duration.4s': '4s',
  'create.duration.8s': '8s',
  'create.duration.15s': '15s',
  'create.estimated.price': 'Geschätzt: {price}',
  'create.model.select': 'Modell auswählen',
  'create.model.loading': 'Lade Modelle...',
  'create.model.loadFailed': 'Modellliste konnte nicht geladen werden',
  'create.model.family.select': 'Modellfamilie auswählen',
  'create.model.family.select.placeholder': 'Bitte wählen Sie eine Modellfamilie',
  'create.model.family.loadFailed': 'Modellfamilienliste konnte nicht geladen werden',
  'create.style.select.placeholder': 'Bitte wählen Sie einen Kunststil (optional, Standard ist das Familienmodell)',
  'create.model.style.loadFailed': 'Stilmodellliste konnte nicht geladen werden',
  'create.model.description': 'Modellbeschreibung',
  'create.model.aspectResolution': 'Seitenverhältnis-Auflösung',
  'create.model.fps': 'Bildrate',
  'create.model.features': 'Unterstützte Funktionen',
  'create.model.feature.cameraMotion': 'Kamerabewegung',
  'create.model.feature.img2video': 'Bild zu Video',
  'create.model.feature.videoEdit': 'Videobearbeitung',
  'create.model.price.perSecond': '/Sek',
  'create.model.detail': 'Details',
  'create.history.title': 'Generierungsverlauf',
  'create.history.refresh': 'Aktualisieren',
  'create.history.empty': 'Kein Generierungsverlauf',
  'create.history.total': 'Gesamt {total} Datensätze',
  'create.history.status.queued': 'In Warteschlange',
  'create.history.status.processing': 'Verarbeitung',
  'create.history.status.success': 'Erfolg',
  'create.history.status.failed': 'Fehlgeschlagen',
  'create.history.status.timeout': 'Zeitüberschreitung',
  'create.history.failed.noImage': 'Generierung fehlgeschlagen',
  'create.history.downloadAll.start': 'Download von {count} Bildern gestartet',
  'create.history.downloadAll.tooltip': 'Alle {count} Bilder herunterladen',
  'create.history.download.tooltip': 'Bild herunterladen',
  'create.history.detail.tooltip': 'Details anzeigen',
  'create.history.noPrompt': 'Kein Prompt',
  'create.history.deleteConfirm.title': 'Löschen bestätigen',
  'create.history.deleteConfirm.content': 'Sind Sie sicher, dass Sie diese Aufgabe löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
  'create.history.deleteSuccess': 'Erfolgreich gelöscht',
  'create.history.deleteFailed': 'Löschen fehlgeschlagen',
  'create.taskDetail.title': 'Aufgabendetails',
  'create.taskDetail.loading': 'Laden...',
  'create.taskDetail.loadFailed': 'Fehler beim Laden der Aufgabendetails',
  'create.taskDetail.noData': 'Keine Daten verfügbar',
  'create.taskDetail.basicInfo': 'Grundinformationen',
  'create.taskDetail.model': 'Modell',
  'create.taskDetail.taskType': 'Aufgabentyp',
  'create.taskDetail.createTime': 'Erstellungszeit',
  'create.taskDetail.duration': 'Generierungsdauer',
  'create.taskDetail.prompt': 'Eingabeaufforderung',
  'create.taskDetail.error': 'Fehlermeldung',
  'create.taskDetail.outputFiles': 'Ausgabedateien',
  'create.taskDetail.downloadAll': 'Alle herunterladen',
  'create.taskDetail.downloadAll.start': 'Download von {count} Bildern gestartet',
  'create.taskDetail.modelInfo': 'Modellinformationen',
  'create.taskDetail.defaultResolution': 'Standardauflösung',
  'create.taskDetail.maxResolution': 'Maximale Auflösung',
  'create.taskDetail.aspectRatios': 'Unterstützte Seitenverhältnisse',
  'create.taskDetail.formats': 'Unterstützte Formate',
  'create.taskDetail.prompt.copied': 'Eingabeaufforderung kopiert',
  'create.taskDetail.liked': 'Gefällt mir',
  'create.taskDetail.like': 'Gefällt mir',
  'create.taskDetail.collected': 'Gesammelt',
  'create.taskDetail.collect': 'Sammeln',
  'create.taskDetail.linkCopied': 'Link kopiert',
  'create.taskDetail.share': 'Teilen',
  'create.taskDetail.outputs': 'Ausgaben',
  'create.taskDetail.preview': 'Vorschau',
  'create.taskDetail.download': 'Herunterladen',
  'create.taskDetail.generationFailed': 'Generierung fehlgeschlagen',
  'create.taskDetail.generating': 'Wird generiert...',
  'create.taskDetail.promptLabel': 'Eingabeaufforderung',
  'create.taskDetail.copy': 'Kopieren',
  'create.taskDetail.executionStats': 'Ausführungsstatistiken',
  'create.taskDetail.creditsCost': 'Guthabenkosten',
  'create.taskDetail.modelSpecs': 'Modellspezifikationen',
  'create.taskDetail.capabilities': 'Funktionen',
  'create.taskDetail.supportedRatios': 'Unterstützte Seitenverhältnisse',
  'create.taskDetail.dataError': 'Datenfehler',
  'create.taskDetail.more': 'Mehr',
  'create.taskDetail.downloading': 'Wird heruntergeladen...',
  'create.taskDetail.points': 'Punkte',
  'create.taskDetail.seconds': 's',
  'create.taskDetail.status.success': 'ERFOLG',
  'create.taskDetail.status.failed': 'FEHLGESCHLAGEN',
  'create.taskDetail.status.processing': 'WIRD VERARBEITET',
  'create.taskDetail.status.queued': 'IN WARTESCHLANGE',
  'create.taskDetail.status.generating': 'WIRD GENERIERT',
  'create.taskDetail.durationLabel': 'Dauer',
  'create.taskDetail.taskParams': 'Aufgabenparameter',
  'create.taskDetail.aspectRatio': 'Seitenverhältnis',
  'create.taskDetail.inputType': 'Eingabetyp',
  'create.taskDetail.modelCode': 'Modellcode',
  'create.taskDetail.regenerate': 'Neu generieren',
  'create.taskDetail.feature.developing': 'Funktion in Entwicklung',
  'create.taskDetail.result': 'Generierungsergebnis',
  'create.taskDetail.copyPrompt': 'Eingabeaufforderung kopieren',
  'create.taskDetail.imageDimensions': 'Abmessungen',
  'create.taskDetail.fileSize': 'Dateigröße',
  'create.taskDetail.loadingImageInfo': 'Bildinformationen werden geladen...',
  'create.history.failed.noVideo': 'Generierung fehlgeschlagen',
  'create.video.generate.cancelled.polling': 'Aufgabenabfrage abgebrochen',
  'create.video.generate.queued': 'Video-Generierungsaufgabe übermittelt, in Warteschlange...',
  'create.video.generate.noUrl': 'Video-Generierung abgeschlossen, aber Video-URL nicht gefunden',
  'create.video.status.checkFailed': 'Aufgabenstatus konnte nicht überprüft werden',
  'create.video.generate.processing': 'Video-Generierungsaufgabe übermittelt, wird verarbeitet...',
  'create.video.taskQueue': 'Aufgabenwarteschlange',
  'create.video.polling': 'Video wird generiert, bitte warten...',
  'create.video.ratio.invalid': 'Bitte wählen Sie ein Video-Seitenverhältnis aus, das vom Modell unterstützt wird',
  'create.waitingTask.queue': 'Aufgabenwarteschlange',
  'create.waitingTask.empty': 'Keine Aufgaben in Bearbeitung',
  'create.waitingTask.generating': 'Wird generiert...',
  'create.waitingTask.queued': 'In Warteschlange',
  'create.waitingTask.cancel': 'Aufgabe abbrechen',
  // HistorySection neue Internationalisierung
  'create.history.copyPrompt': 'Prompt kopieren',
  'create.history.download': 'Herunterladen',
  'create.history.delete': 'Löschen',
  'create.history.generating': 'Wird generiert...',
  'create.history.generationFailed': 'Generierung fehlgeschlagen',
  'create.history.noPreview': 'Keine Vorschau',
  // ImageToVideo neue Internationalisierung
  'create.i2v.fileType.error': 'Bitte wählen Sie eine Bilddatei',
  'create.i2v.fileSize.error': 'Die Bilddateigröße darf 10 MB nicht überschreiten',
  'create.i2v.imageSize.error': 'Die Bildhöhe muss mindestens {minHeight}px betragen, die aktuelle Bildgröße ist {width}x{height}px',
  'create.i2v.fileRead.error': 'Bild konnte nicht gelesen werden',
  'create.i2v.replaceImage': 'Bild ersetzen',
  'create.i2v.upload.supportedFormats': 'Unterstützt JPG, PNG, WebP, JFIF',
  'create.i2v.upload.required': 'Bitte laden Sie ein Referenzbild hoch',
  'create.i2v.upload': 'Referenzbild Hochladen (Startbild)',
  'create.i2v.upload.click': 'Klicken oder ziehen zum Hochladen',
  'create.i2v.prompt.required': 'Bitte geben Sie eine Bewegungsbeschreibung ein',
  'create.i2v.uploading.image': 'Bild wird in die Cloud hochgeladen...',
  'create.i2v.upload.success': 'Bild erfolgreich hochgeladen',
  'create.i2v.upload.failed': 'Bild-Upload fehlgeschlagen, bitte versuchen Sie es erneut',
  'create.i2v.original': 'Original (Startbild)',
  'create.i2v.result': 'Generierungsvergleich',
  'create.i2v.empty': 'Vergleich der generierten Ergebnisse mit dem Originalbild wird hier angezeigt',
  'create.generate.i2v': 'Videogenerierung starten',
  'create.prompt.i2v.placeholder': 'z.B. Die Person im Bild zum Gehen bringen, Blätter im Hintergrund im Wind schwingen...',
  'create.prompt.enhance.tooltip': 'Prompt mit KI anreichern, um die Beschreibung detaillierter und lebendiger zu machen',
  'create.prompt.enhance': 'KI-Anreicherung',
  'create.prompt.enhance.empty': 'Bitte geben Sie zuerst einen Basis-Prompt ein',
  'create.prompt.enhance.success': 'Prompt erfolgreich angereichert!',
  'create.prompt.enhance.empty.result': 'Kein angereicherter Prompt generiert, bitte versuchen Sie es erneut',
  'create.prompt.enhance.error': 'Prompt-Anreicherung fehlgeschlagen, bitte versuchen Sie es erneut',
  'create.prompt.version.history': 'Versionsverlauf',
  'create.prompt.version.history.tooltip': 'Prompt-Versionsverlauf anzeigen',
  // TaskDetailModal neue Internationalisierung
  'create.taskDetail.unnamedTask': 'Unbenannte Aufgabe',
  'create.taskDetail.prompt.title': 'Prompt',
  'create.taskDetail.tokenCost': 'Token-Kosten',
  'create.taskDetail.publish': 'In Community veröffentlichen',
  'create.taskDetail.selectCover': 'Titelbild auswählen',
  'create.taskDetail.selectChannel': 'Kanal auswählen',
  'create.taskDetail.selectChallenge': 'Herausforderung auswählen',
  'create.taskDetail.publishSuccess': 'Erfolgreich veröffentlicht',
  'create.taskDetail.loadChannelsFailed': 'Kanäle konnten nicht geladen werden',
  'create.taskDetail.loadChallengesFailed': 'Herausforderungen konnten nicht geladen werden',
  'create.taskDetail.publishFailed': 'Veröffentlichung fehlgeschlagen',
  'create.taskDetail.daysLeft': 'Noch {days} Tage',
  // ModelDetailModal neue Internationalisierung
  'create.model.capability.t2v': 'T2V (Text zu Video)',
  'create.model.capability.img2video': 'Bild zu Video',
  'create.model.capability.videoEdit': 'Video-Bearbeitung',
  'create.model.capability.characterConsistency': 'Charakterkonsistenz',
  'create.model.capability.reference': 'Referenz',
  'create.model.capability.cameraMotion': 'Kamerabewegung',
  'create.model.aspectRatios': 'Seitenverhältnisse',
  'create.model.resolution': 'Auflösung',
  'create.model.resolution.default': 'Standard',
  'create.model.resolution.max': 'Max',
  'create.model.duration': 'Dauer',
  'create.model.formats': 'Formate',
  'create.model.like': 'Gefällt mir',
  'create.model.liked': 'Gefällt mir',
  'create.model.unliked': 'Gefällt mir nicht mehr',
  'create.model.favorite': 'Favorit',
  'create.model.favorited': 'Zu Favoriten hinzugefügt',
  'create.model.unfavorited': 'Aus Favoriten entfernt',
  'create.model.share': 'Teilen',
  'create.model.linkCopied': 'Link kopiert',
  'create.model.capabilities': 'Funktionen',
  'create.model.free': 'Kostenlos',
  'create.model.tokenCost.display': '{count} token',
  // Weitere neue Schlüssel
  'create.aspectRatio.portrait': 'Hochformat',
  'create.aspectRatio.landscape': 'Querformat',
  'create.video.ratio.placeholder': 'Bitte wählen Sie das Video-Seitenverhältnis',
  'create.video.format.placeholder': 'Bitte wählen Sie das Ausgabeformat',
  'create.video.style': 'Video-Stil',
  'create.video.style.tooltip': 'Video-Generierungsstil auswählen',
  'create.video.style.placeholder': 'Bitte wählen Sie den Video-Stil',
  'create.video.quality': 'Video-Qualität',
  'create.video.quality.tooltip': 'Video-Generierungsqualität auswählen',
  'create.video.quality.placeholder': 'Bitte wählen Sie die Video-Qualität',
  'create.duration.select.placeholder': 'Bitte wählen Sie die Videodauer',
  'create.model.select.placeholder': 'Bitte wählen Sie zuerst ein Modell',
  'video.not.supported': 'Ihr Browser unterstützt keine Videowiedergabe.',
  // UnderDevelopment Internationalisierung
  'underDevelopment.comingSoon': 'Demnächst',
  'underDevelopment.title': 'Funktion in Entwicklung',
  'underDevelopment.subtitle': 'Wir arbeiten hart an der Entwicklung dieser Funktion, bitte bleiben Sie dran!',
  'underDevelopment.backHome': 'Zur Startseite',
  'underDevelopment.goBack': 'Zurück',
  // UserMenu Internationalisierung
  'userMenu.email.notBound': 'E-Mail nicht gebunden',
  'userMenu.status.verified': 'Verifiziert',
  'userMenu.status.guest': 'Gast',
  'userMenu.recharge': 'Jetzt aufladen',
  'userMenu.community': 'Community',
  'userMenu.group.account': 'Kontoeinstellungen',
  'userMenu.group.assets': 'Vermögen & Bestellungen',
  'userMenu.group.workspace': 'Arbeitsbereich',
  'userMenu.group.support': 'Support',
  'userMenu.item.profile': 'Profil',
  'userMenu.item.settings': 'Einstellungen',
  'userMenu.item.security': 'Sicherheit',
  'userMenu.item.privacy': 'Datenschutz',
  'userMenu.item.wallet': 'Mein Wallet',
  'userMenu.item.subscription': 'Abonnement',
  'userMenu.item.orders': 'Bestellverlauf',
  'userMenu.item.works': 'Meine Werke',
  'userMenu.item.notifications': 'Benachrichtigungen',
  'userMenu.item.help': 'Hilfezentrum',
  'userMenu.item.invite': 'Freunde einladen',
  'userMenu.item.feedback': 'Feedback',
  'userMenu.item.about': 'Über uns',
  'userMenu.level': 'Level',
  'userMenu.member.vip1': 'Basis-Mitglied',
  'userMenu.member.vip2': 'Silber-Mitglied',
  'userMenu.member.vip3': 'Gold-Mitglied',
  'userMenu.member.vip4': 'Diamant-Mitglied',
  'userMenu.member.vip5': 'Ultimatives Mitglied',
  'userMenu.logout': 'Abmelden',
  // Recharge Agreement Internationalisierung
  'rechargeAgreement.back': 'Zurück',
  'rechargeAgreement.title': 'Auflade-Service-Vereinbarung',
  'rechargeAgreement.lastUpdated': 'Zuletzt aktualisiert: ',
  'rechargeAgreement.goRecharge': 'Zur Aufladung',
  'rechargeAgreement.section1.title': 'I. Vereinbarungsbereich',
  'rechargeAgreement.section1.content1': 'Diese Vereinbarung ist eine rechtliche Vereinbarung zwischen Ihnen und der Plattform bezüglich der Aufladedienste. Bitte lesen Sie vor der Nutzung des Aufladedienstes alle Inhalte dieser Vereinbarung sorgfältig durch. Wenn Sie mit einem Inhalt dieser Vereinbarung nicht einverstanden sind oder die Bedeutung der relevanten Bedingungen nicht genau verstehen können, führen Sie bitte keine Aufladevorgänge durch.',
  'rechargeAgreement.section1.content2': 'Wenn Sie auf "Zustimmen" klicken oder Aufladevorgänge durchführen, bedeutet dies, dass Sie alle Inhalte dieser Vereinbarung vollständig gelesen, verstanden und akzeptiert haben.',
  'rechargeAgreement.section2.title': 'II. Aufladeanweisungen',
  'rechargeAgreement.section2.subtitle1': '2.1 Auflademethoden',
  'rechargeAgreement.section2.content1': 'Die Plattform unterstützt die folgenden Auflademethoden:',
  'rechargeAgreement.section2.method1': 'Alipay',
  'rechargeAgreement.section2.method2': 'WeChat Pay',
  'rechargeAgreement.section2.method3': 'Bankkarte (UnionPay, Visa, MasterCard)',
  'rechargeAgreement.section2.method4': 'USDT Kryptowährung (ERC20/TRC20)',
  'rechargeAgreement.section2.subtitle2': '2.2 Aufladewährung',
  'rechargeAgreement.section2.content2': 'Die Plattform unterstützt die Aufladung in folgenden Währungen: CNY, USD, USDT. Zwischen verschiedenen Währungen kann eine Wechselkursumrechnung erfolgen, der spezifische Wechselkurs richtet sich nach dem Echtzeit-Wechselkurs zum Zeitpunkt der Aufladung.',
  'rechargeAgreement.section2.subtitle3': '2.3 Aufladegrenzen',
  'rechargeAgreement.section2.limit1': 'Mindestbetrag pro Aufladung: 1 Yuan (oder gleichwertig in anderen Währungen)',
  'rechargeAgreement.section2.limit2': 'Höchstbetrag pro Aufladung: 50.000 Yuan (oder gleichwertig in anderen Währungen)',
  'rechargeAgreement.section2.limit3': 'Tägliche kumulative Aufladegrenze: 100.000 Yuan (oder gleichwertig in anderen Währungen)',
  'rechargeAgreement.section2.note': 'Hinweis: Die Aufladegrenzen können je nach Zahlungsmethode, Kontostufe und anderen Faktoren variieren. Details finden Sie auf der Aufladeseite.',
  'rechargeAgreement.section3.title': 'III. Aufladeeingang',
  'rechargeAgreement.section3.subtitle1': '3.1 Eingangszeit',
  'rechargeAgreement.section3.time1': 'Alipay, WeChat Pay: Sofortiger Eingang',
  'rechargeAgreement.section3.time2': 'Bankkarte: 1-3 Werktage',
  'rechargeAgreement.section3.time3': 'USDT: Je nach Blockchain-Bestätigungszeit, normalerweise 10-30 Minuten',
  'rechargeAgreement.section3.subtitle2': '3.2 Ausnahmebehandlung',
  'rechargeAgreement.section3.content1': 'Wenn die Aufladung nicht rechtzeitig eingeht, bewahren Sie bitte den Zahlungsbeleg auf und kontaktieren Sie den Kundenservice umgehend. Die Plattform wird Ihr Aufladeproblem so schnell wie möglich nach Überprüfung bearbeiten.',
  'rechargeAgreement.section4.title': 'IV. Rückerstattungsrichtlinie',
  'rechargeAgreement.section4.important': 'Wichtig: Nach erfolgreicher Aufladung unterstützt das Kontoguthaben keine direkte Rückerstattung. Das Guthaben kann nur für den Konsum von Plattformdiensten verwendet werden.',
  'rechargeAgreement.section4.subtitle1': '4.1 Rückerstattungsbedingungen',
  'rechargeAgreement.section4.content1': 'Sie können in folgenden Fällen eine Rückerstattung beantragen:',
  'rechargeAgreement.section4.refund1': 'Doppelte Aufladung aufgrund von Plattformsystemfehlern',
  'rechargeAgreement.section4.refund2': 'Dienst aufgrund von Plattformgründen nicht verfügbar und Kontoguthaben wurde nicht verbraucht',
  'rechargeAgreement.section4.refund3': 'Andere besondere Umstände, die von der Plattform nach Überprüfung genehmigt wurden',
  'rechargeAgreement.section4.subtitle2': '4.2 Rückerstattungsprozess',
  'rechargeAgreement.section4.process1': 'Rückerstattungsantrag einreichen und Grund angeben',
  'rechargeAgreement.section4.process2': 'Plattformüberprüfung (normalerweise 3-7 Werktage)',
  'rechargeAgreement.section4.process3': 'Nach Genehmigung wird die Rückerstattung auf Ihr Zahlungskonto zurückerstattet',
  'rechargeAgreement.section5.title': 'V. Kontosicherheit',
  'rechargeAgreement.section5.content1': 'Sie sind dafür verantwortlich, Ihre Kontoinformationen und Ihr Passwort ordnungsgemäß aufzubewahren. Die Plattform übernimmt keine Verantwortung für Verluste, die durch Kontodiebstahl oder Passwortlecks aufgrund Ihrer eigenen Gründe entstehen.',
  'rechargeAgreement.section5.content2': 'Wenn Sie Kontoanomalien feststellen, kontaktieren Sie bitte sofort den Kundenservice und ändern Sie Ihr Passwort. Die Plattform wird Ihnen bei der Bearbeitung verwandter Probleme helfen.',
  'rechargeAgreement.section6.title': 'VI. Haftungsausschluss',
  'rechargeAgreement.section6.disclaimer1': 'Die Plattform übernimmt keine Verantwortung für Dienstunterbrechungen aufgrund von höherer Gewalt (wie Naturkatastrophen, Krieg, Regierungshandlungen usw.)',
  'rechargeAgreement.section6.disclaimer2': 'Bei Aufladeproblemen aufgrund von Fehlern bei Drittanbieter-Zahlungsplattformen hilft die Plattform bei der Bearbeitung, übernimmt aber keine direkte Verantwortung',
  'rechargeAgreement.section6.disclaimer3': 'Verluste, die durch Verstöße des Benutzers gegen diese Vereinbarung oder relevante Gesetze und Vorschriften entstehen, werden vom Benutzer selbst getragen',
  'rechargeAgreement.section7.title': 'VII. Vereinbarungsänderung',
  'rechargeAgreement.section7.content1': 'Die Plattform hat das Recht, diese Vereinbarung gemäß den Geschäftsentwicklungsbedürfnissen zu ändern. Nach Änderung der Vereinbarung wird diese an prominenter Stelle auf der Plattform bekannt gegeben. Wenn Sie den Aufladedienst weiterhin nutzen, gilt dies als Annahme der geänderten Vereinbarung.',
  'rechargeAgreement.section8.title': 'VIII. Kontaktinformationen',
  'rechargeAgreement.section8.content1': 'Wenn Sie Fragen zu dieser Vereinbarung haben oder eine Rückerstattung beantragen oder Aufladeprobleme behandeln müssen, kontaktieren Sie uns bitte über die folgenden Methoden:',
  'rechargeAgreement.section8.contact1': 'Kundenservice-E-Mail: support@example.com',
  'rechargeAgreement.section8.contact2': 'Online-Kundenservice: Werktage 9:00-18:00',
  'rechargeAgreement.section8.contact3': 'Hilfezentrum: FAQ anzeigen',
  // Profil-Internationalisierung
  'profile.editProfile': 'Profil Bearbeiten',
  'profile.creditScore': 'Kreditwürdigkeit',
  'profile.level': 'Stufe',
  'profile.balance': 'Saldo',
  'profile.tab.basic': 'Grundinformationen',
  'profile.tab.account': 'Kontovermögen',
  'profile.section.personal': 'Persönliche Informationen',
  'profile.section.contact': 'Kontakt',
  'profile.section.wallet': 'USDT-Wallet',
  'profile.label.username': 'Benutzername',
  'profile.label.realName': 'Echter Name',
  'profile.label.accountStatus': 'Kontostatus',
  'profile.label.phone': 'Telefonnummer',
  'profile.label.email': 'E-Mail',
  'profile.label.registerTime': 'Registrierungszeit',
  'profile.label.availableBalance': 'Verfügbares Guthaben',
  'profile.label.frozenAmount': 'Eingefrorener Betrag',
  'profile.value.notVerified': 'Nicht Verifiziert',
  'profile.value.notBound': 'Nicht Gebunden',
  'profile.value.noAddress': 'Keine TRC20-Adresse',
  'profile.value.noDescription': 'Diese Person ist faul und hat nichts geschrieben',
  'profile.status.normal': 'Normal',
  'profile.status.disabled': 'Deaktiviert',
  'profile.tooltip.verified': 'Verifiziert',
  'profile.tooltip.unverified': 'Jetzt Verifizieren',
  'profile.banner.construction': 'Diese Seite befindet sich im Aufbau...',
  'profile.modal.title': 'Profil Bearbeiten',
  'profile.modal.cancel': 'Abbrechen',
  'profile.modal.save': 'Änderungen Speichern',
  'profile.modal.avatarSection': 'Avatar-Einstellungen',
  'profile.modal.basicSection': 'Grundinformationen',
  'profile.modal.contactSection': 'Kontaktinformationen',
  'profile.modal.changeAvatar': 'Avatar Ändern',
  'profile.modal.avatarHint': 'Unterstützt JPG-, PNG-Formate, maximal 2MB',
  'profile.modal.nickname': 'Spitzname',
  'profile.modal.nicknamePlaceholder': 'Geben Sie Ihren Spitznamen ein',
  'profile.modal.description': 'Biografie',
  'profile.modal.descriptionPlaceholder': 'Stellen Sie sich in einem Satz vor...',
  'profile.modal.phone': 'Telefon',
  'profile.modal.email': 'E-Mail',
  'profile.message.avatarSizeLimit': 'Die Bildgröße darf 2MB nicht überschreiten',
  'profile.message.avatarUploadSuccess': 'Avatar erfolgreich hochgeladen',
  'profile.message.saveSuccess': 'Erfolgreich gespeichert',
  'profile.message.saveFailed': 'Speichern fehlgeschlagen',
  'profile.message.uploadAvatarFailed': 'Avatar-Upload fehlgeschlagen',
  'profile.message.operationFailed': 'Operation fehlgeschlagen',
  'privacyPreferences.title': 'Datenschutzeinstellungen',
  'privacyPreferences.description': 'Verwalten Sie Ihre Datenschutzeinstellungen und steuern Sie, wie wir Ihre Daten sammeln und verwenden',
  'privacyPreferences.back': 'Zurück',
  'privacyPreferences.save': 'Einstellungen speichern',
  'privacyPreferences.saveSuccess': 'Datenschutzeinstellungen erfolgreich gespeichert',
  'privacyPreferences.saveError': 'Speichern fehlgeschlagen, bitte versuchen Sie es später erneut',
  'privacyPreferences.required': 'Erforderlich',
  'privacyPreferences.info': 'Ihre Datenschutzeinstellungen werden lokal gespeichert und bei Ihrem nächsten Besuch automatisch angewendet. Melden Sie sich an, um die Einstellungen mit der Cloud zu synchronisieren.',
  'privacyPreferences.info.loggedIn': 'Ihre Datenschutzeinstellungen werden in Ihrem Konto gespeichert und auf allen Geräten synchronisiert. Sie können jederzeit zu dieser Seite zurückkehren, um diese Einstellungen zu ändern.',
  'cookieBanner.message': 'Wir verwenden Cookies und lokalen Speicher für Anmeldung, Design und Grundfunktionen. Mit dem Fortfahren stimmen Sie unserer Datenschutzrichtlinie zu.',
  'cookieBanner.acceptAll': 'Alle akzeptieren',
  'cookieBanner.essentialOnly': 'Nur erforderlich',
  'cookieBanner.settings': 'Einstellungen',
  'privacyPreferences.cookies.title': 'Cookie-Einstellungen',
  'privacyPreferences.cookies.description': 'Cookies helfen uns, ein besseres Service-Erlebnis zu bieten. Sie können wählen, bestimmte Arten von Cookies zu akzeptieren oder abzulehnen.',
  'privacyPreferences.cookies.essential': 'Erforderliche Cookies',
  'privacyPreferences.cookies.essential.desc': 'Diese Cookies sind für das ordnungsgemäße Funktionieren der Website erforderlich und können nicht deaktiviert werden. Sie werden normalerweise für Sicherheit, Anmeldung und grundlegende Funktionen verwendet.',
  'privacyPreferences.cookies.functional': 'Funktionale Cookies',
  'privacyPreferences.cookies.functional.desc': 'Diese Cookies ermöglichen es der Website, Ihre Auswahl zu speichern und erweiterte Funktionen und personalisierte Erfahrungen zu bieten.',
  'privacyPreferences.cookies.analytics': 'Analyse-Cookies',
  'privacyPreferences.cookies.analytics.desc': 'Diese Cookies helfen uns zu verstehen, wie Besucher die Website nutzen, damit wir unsere Dienste verbessern können.',
  'privacyPreferences.cookies.marketing': 'Marketing-Cookies',
  'privacyPreferences.cookies.marketing.desc': 'Diese Cookies werden verwendet, um Ihre Browsing-Aktivitäten zu verfolgen, um Ihnen relevante Anzeigen und Inhalte anzuzeigen.',
  'privacyPreferences.data.title': 'Datensammlungseinstellungen',
  'privacyPreferences.data.description': 'Steuern Sie, wie wir Ihre Daten sammeln und verwenden, um das Service-Erlebnis zu verbessern.',
  'privacyPreferences.data.collection': 'Datensammlung',
  'privacyPreferences.data.collection.desc': 'Erlauben Sie uns, notwendige Nutzungsdaten zu sammeln, um Dienste bereitzustellen und zu verbessern.',
  'privacyPreferences.data.analytics': 'Datenanalyse',
  'privacyPreferences.data.analytics.desc': 'Erlauben Sie uns, Ihre Nutzungsmuster zu analysieren, um die Serviceleistung und Benutzererfahrung zu optimieren.',
  'privacyPreferences.data.personalization': 'Personalisierung',
  'privacyPreferences.data.personalization.desc': 'Erlauben Sie uns, personalisierte Inhalte und Empfehlungen basierend auf Ihren Präferenzen und Nutzungsgewohnheiten bereitzustellen.',
  'privacyPreferences.marketing.title': 'Marketing-Einstellungen',
  'privacyPreferences.marketing.description': 'Wählen Sie die Arten von Marketing-Kommunikationen aus, die Sie erhalten möchten.',
  'privacyPreferences.marketing.emails': 'Marketing-E-Mails',
  'privacyPreferences.marketing.emails.desc': 'Erhalten Sie E-Mail-Benachrichtigungen über Produktaktualisierungen, Werbeaktionen und Sonderangebote.',
  'privacyPreferences.marketing.sms': 'Marketing-SMS',
  'privacyPreferences.marketing.sms.desc': 'Erhalten Sie SMS-Benachrichtigungen über wichtige Aktualisierungen und Werbeaktionen.',
  'privacyPreferences.marketing.push': 'Push-Benachrichtigungen',
  'privacyPreferences.marketing.push.desc': 'Erhalten Sie Browser-Push-Benachrichtigungen, einschließlich Produktaktualisierungen und wichtiger Nachrichten.',
  'privacyPreferences.thirdParty.title': 'Drittanbieter-Datenaustausch',
  'privacyPreferences.thirdParty.description': 'Steuern Sie, ob Ihre Daten mit Drittanbieter-Dienstleistern geteilt werden dürfen.',
  'privacyPreferences.thirdParty.sharing': 'Drittanbieter-Datenaustausch',
  'privacyPreferences.thirdParty.sharing.desc': 'Erlauben Sie uns, anonymisierte Nutzungsdaten mit vertrauenswürdigen Drittanbieter-Dienstleistern zu teilen, um Dienste zu verbessern.',
  
  // Datenschutzrichtlinie
  'privacyPolicy.title': 'Datenschutzrichtlinie',
  'privacyPolicy.lastUpdated': 'Zuletzt aktualisiert: {date}',
  'privacyPolicy.intro1': 'Diese Datenschutzrichtlinie beschreibt, wie die AIMATEX-Plattform (im Folgenden "wir" oder "diese Plattform") Ihre persönlichen Informationen sammelt, verwendet, speichert und schützt, wenn Sie unsere Dienste nutzen, sowie Ihre Datenschutzrechte. Wir legen großen Wert auf den Schutz Ihrer Privatsphäre. Bitte lesen Sie diese Datenschutzrichtlinie sorgfältig durch.',
  'privacyPolicy.intro2': 'Durch die Nutzung unserer Dienste stimmen Sie dieser Datenschutzrichtlinie zu. Wenn Sie mit einem Teil dieser Datenschutzrichtlinie nicht einverstanden sind, verwenden Sie bitte unsere Dienste nicht.',
  'privacyPolicy.section1.title': 'I. Von uns gesammelte Informationen',
  'privacyPolicy.section1.1.title': '1.1 Von Ihnen bereitgestellte Informationen',
  'privacyPolicy.section1.1.intro': 'Bei der Nutzung dieses Dienstes müssen Sie möglicherweise die folgenden Informationen bereitstellen:',
  'privacyPolicy.section1.1.item1.label': 'Kontoinformationen',
  'privacyPolicy.section1.1.item1.desc': 'Benutzername, E-Mail-Adresse, Passwort, Telefonnummer usw.',
  'privacyPolicy.section1.1.item2.label': 'Profilinformationen',
  'privacyPolicy.section1.1.item2.desc': 'Avatar, Spitzname, Biografie usw. (optional)',
  'privacyPolicy.section1.1.item3.label': 'Zahlungsinformationen',
  'privacyPolicy.section1.1.item3.desc': 'Zahlungsmethoden, Rechnungsadresse usw. (für die Zahlungsabwicklung)',
  'privacyPolicy.section1.1.item4.label': 'Generierte Inhalte',
  'privacyPolicy.section1.1.item4.desc': 'Von Ihnen hochgeladene Textaufforderungen, Referenzbilder, generierte Videos, Musik, Bilder, 3D-Modelle usw.',
  'privacyPolicy.section1.2.title': '1.2 Automatisch gesammelte Informationen',
  'privacyPolicy.section1.2.intro': 'Wenn Sie diesen Dienst nutzen, können wir automatisch die folgenden Informationen sammeln:',
  'privacyPolicy.section1.2.item1.label': 'Geräteinformationen',
  'privacyPolicy.section1.2.item1.desc': 'Gerätetyp, Betriebssystem, Browsertyp und -version, Gerätekennung usw.',
  'privacyPolicy.section1.2.item2.label': 'Nutzungsdaten',
  'privacyPolicy.section1.2.item2.desc': 'Zugriffszeit, besuchte Seiten, verwendete Funktionen, Betriebsaufzeichnungen usw.',
  'privacyPolicy.section1.2.item3.label': 'Netzwerkinformationen',
  'privacyPolicy.section1.2.item3.desc': 'IP-Adresse, Netzwerktyp, Netzbetreiber usw.',
  'privacyPolicy.section1.2.item4.label': 'Protokollinformationen',
  'privacyPolicy.section1.2.item4.desc': 'Fehlerprotokolle, Leistungsdaten usw.',
  'privacyPolicy.section1.3.title': '1.3 Cookies und ähnliche Technologien',
  'privacyPolicy.section1.3.intro': 'Wir verwenden Cookies und ähnliche Technologien für:',
  'privacyPolicy.section1.3.item1': 'Aufrechterhaltung Ihres Anmeldestatus',
  'privacyPolicy.section1.3.item2': 'Speichern Ihrer Präferenzen (wie Sprache, Thema usw.)',
  'privacyPolicy.section1.3.item3': 'Analyse der Dienstnutzung zur Verbesserung der Dienstqualität',
  'privacyPolicy.section1.3.item4': 'Bereitstellung einer personalisierten Erfahrung',
  'privacyPolicy.section1.3.note': 'Sie können Cookies über die Browsereinstellungen ablehnen, dies kann jedoch die Nutzung einiger Funktionen beeinträchtigen.',
  'privacyPolicy.section2.title': 'II. Zweck der Informationsnutzung',
  'privacyPolicy.section2.intro': 'Wir sammeln und verwenden Ihre Informationen für folgende Zwecke:',
  'privacyPolicy.section2.item1.label': 'Bereitstellung von Diensten',
  'privacyPolicy.section2.item1.desc': 'Bearbeitung Ihrer Inhaltsgenerierungsanfragen (Videos, Musik, Bilder, 3D-Modelle usw.), Verwaltung Ihres Kontos und Ihrer Werke usw.',
  'privacyPolicy.section2.item2.label': 'Verbesserung der Dienste',
  'privacyPolicy.section2.item2.desc': 'Analyse der Nutzung, Optimierung der Dienstleistung und Benutzererfahrung',
  'privacyPolicy.section2.item3.label': 'Kontoverwaltung',
  'privacyPolicy.section2.item3.desc': 'Identitätsüberprüfung, Zahlungsabwicklung, Versand von Benachrichtigungen usw.',
  'privacyPolicy.section2.item4.label': 'Sicherheit',
  'privacyPolicy.section2.item4.desc': 'Erkennung und Verhinderung von Betrug, Missbrauch, Sicherheitsbedrohungen usw.',
  'privacyPolicy.section2.item5.label': 'Kundensupport',
  'privacyPolicy.section2.item5.desc': 'Beantwortung Ihrer Anfragen, Bearbeitung von Beschwerden und Feedback usw.',
  'privacyPolicy.section2.item6.label': 'Rechtliche Compliance',
  'privacyPolicy.section2.item6.desc': 'Einhaltung gesetzlicher Anforderungen, Zusammenarbeit mit Strafverfolgungsbehörden usw.',
  'privacyPolicy.section3.title': 'III. Informationsaustausch und Offenlegung',
  'privacyPolicy.section3.1.title': '3.1 Wir verkaufen Ihre persönlichen Informationen nicht',
  'privacyPolicy.section3.1.content': 'Wir verkaufen, vermieten oder handeln Ihre persönlichen Informationen nicht an Dritte.',
  'privacyPolicy.section3.2.title': '3.2 Dienstleister',
  'privacyPolicy.section3.2.intro': 'Wir können Informationen mit folgenden Arten von Dienstleistern teilen:',
  'privacyPolicy.section3.2.item1.label': 'Cloud-Dienstleister',
  'privacyPolicy.section3.2.item1.desc': 'Für Datenspeicherung und -verarbeitung',
  'privacyPolicy.section3.2.item2.label': 'Zahlungsdienstleister',
  'privacyPolicy.section3.2.item2.desc': 'Für die Abwicklung von Zahlungstransaktionen',
  'privacyPolicy.section3.2.item3.label': 'Analysedienstleister',
  'privacyPolicy.section3.2.item3.desc': 'Für die Analyse der Dienstnutzung',
  'privacyPolicy.section3.2.item4.label': 'Kundensupport-Dienstleister',
  'privacyPolicy.section3.2.item4.desc': 'Für die Bereitstellung von Kundensupport',
  'privacyPolicy.section3.2.note': 'Diese Dienstleister dürfen die Informationen nur verwenden, um uns Dienste zu erbringen, und nicht für andere Zwecke.',
  'privacyPolicy.section3.3.title': '3.3 Rechtliche Anforderungen',
  'privacyPolicy.section3.3.intro': 'Wir können Ihre Informationen in folgenden Fällen offenlegen:',
  'privacyPolicy.section3.3.item1': 'Einhaltung von Gesetzen, Vorschriften, Gerichtsbeschlüssen oder behördlichen Anforderungen',
  'privacyPolicy.section3.3.item2': 'Schutz unserer Rechte, unseres Eigentums oder unserer Sicherheit',
  'privacyPolicy.section3.3.item3': 'Verhinderung oder Untersuchung möglicher illegaler Aktivitäten',
  'privacyPolicy.section3.3.item4': 'Schutz der Sicherheit von Benutzern oder der Öffentlichkeit',
  'privacyPolicy.section3.4.title': '3.4 Unternehmensübertragung',
  'privacyPolicy.section3.4.content': 'Bei einer Fusion, Übernahme oder Vermögensübertragung können Ihre Informationen übertragen werden. Wir werden Sie vor der Übertragung benachrichtigen.',
  'privacyPolicy.section4.title': 'IV. Informationsspeicherung und Sicherheit',
  'privacyPolicy.section4.1.title': '4.1 Speicherort',
  'privacyPolicy.section4.1.content': 'Ihre Informationen können auf Servern in der Volksrepublik China oder im Ausland gespeichert werden. Wir werden angemessene Maßnahmen ergreifen, um die Sicherheit der Informationen zu gewährleisten.',
  'privacyPolicy.section4.2.title': '4.2 Aufbewahrungsdauer',
  'privacyPolicy.section4.2.intro': 'Wir speichern Ihre Informationen nur für den erforderlichen Zeitraum:',
  'privacyPolicy.section4.2.item1': 'Kontoinformationen: Während der Dauer Ihres Kontos und für einen Zeitraum nach der Kündigung',
  'privacyPolicy.section4.2.item2': 'Generierte Inhalte: Gemäß Ihren Einstellungen oder gesetzlichen Anforderungen gespeichert',
  'privacyPolicy.section4.2.item3': 'Nutzungsdaten: Normalerweise für einen kürzeren Zeitraum gespeichert, für Analyse und Dienstverbesserung',
  'privacyPolicy.section4.3.title': '4.3 Sicherheitsmaßnahmen',
  'privacyPolicy.section4.3.intro': 'Wir ergreifen die folgenden Sicherheitsmaßnahmen zum Schutz Ihrer Informationen:',
  'privacyPolicy.section4.3.item1': 'Verschlüsselte Übertragung und Speicherung',
  'privacyPolicy.section4.3.item2': 'Zugriffskontrolle und Authentifizierung',
  'privacyPolicy.section4.3.item3': 'Regelmäßige Sicherheitsaudits und Schwachstellenscans',
  'privacyPolicy.section4.3.item4': 'Mitarbeiterschulung und Vertraulichkeitsvereinbarungen',
  'privacyPolicy.section4.3.note': 'Bitte beachten Sie, dass keine Sicherheitsmaßnahme zu 100% sicher ist. Wir können keine absolute Sicherheit der Informationen gewährleisten.',
  'privacyPolicy.section5.title': 'V. Ihre Rechte',
  'privacyPolicy.section5.intro': 'Gemäß den geltenden Gesetzen und Vorschriften haben Sie folgende Rechte:',
  'privacyPolicy.section5.item1.label': 'Recht auf Zugang',
  'privacyPolicy.section5.item1.desc': 'Einsicht in Ihre persönlichen Informationen, die wir besitzen',
  'privacyPolicy.section5.item2.label': 'Recht auf Berichtigung',
  'privacyPolicy.section5.item2.desc': 'Korrektur ungenauer oder unvollständiger Informationen',
  'privacyPolicy.section5.item3.label': 'Recht auf Löschung',
  'privacyPolicy.section5.item3.desc': 'Löschung Ihrer persönlichen Informationen verlangen (außer wenn gesetzlich vorgeschrieben)',
  'privacyPolicy.section5.item4.label': 'Recht auf Widerruf der Einwilligung',
  'privacyPolicy.section5.item4.desc': 'Widerruf Ihrer Einwilligung zur Informationsverarbeitung',
  'privacyPolicy.section5.item5.label': 'Recht auf Datenübertragbarkeit',
  'privacyPolicy.section5.item5.desc': 'Erhalt einer Kopie Ihrer persönlichen Informationen',
  'privacyPolicy.section5.item6.label': 'Widerspruchsrecht',
  'privacyPolicy.section5.item6.desc': 'Widerspruch gegen bestimmte Informationsverarbeitungsaktivitäten',
  'privacyPolicy.section5.note': 'Um die oben genannten Rechte auszuüben, kontaktieren Sie uns bitte über die Kontaktinformationen am Ende dieser Datenschutzrichtlinie.',
  'privacyPolicy.section6.title': 'VI. Schutz von Minderjährigen',
  'privacyPolicy.section6.content1': 'Dieser Dienst richtet sich hauptsächlich an Benutzer über 18 Jahre. Wenn Sie unter 18 Jahre alt sind, verwenden Sie bitte diesen Dienst mit Zustimmung und unter Aufsicht Ihres Erziehungsberechtigten.',
  'privacyPolicy.section6.content2': 'Wenn wir feststellen, dass wir persönliche Informationen von Benutzern unter 18 Jahren ohne Zustimmung des Erziehungsberechtigten gesammelt haben, werden wir die relevanten Informationen so schnell wie möglich löschen.',
  'privacyPolicy.section7.title': 'VII. Links zu Dritten',
  'privacyPolicy.section7.content': 'Dieser Dienst kann Links zu Websites Dritter enthalten. Wir sind nicht für die Datenschutzpraktiken dieser Websites Dritter verantwortlich. Beim Besuch dieser Websites lesen Sie bitte deren Datenschutzrichtlinien.',
  'privacyPolicy.section8.title': 'VIII. Änderungen der Datenschutzrichtlinie',
  'privacyPolicy.section8.content1': 'Wir können diese Datenschutzrichtlinie von Zeit zu Zeit aktualisieren. Wesentliche Änderungen werden Ihnen mindestens 30 Tage vor Inkrafttreten mitgeteilt. Die fortgesetzte Nutzung des Dienstes bedeutet Ihre Zustimmung zur aktualisierten Datenschutzrichtlinie.',
  'privacyPolicy.section8.content2': 'Wir aktualisieren das Datum "Zuletzt aktualisiert" oben auf dieser Seite und informieren Sie über wichtige Änderungen per E-Mail oder In-App-Benachrichtigungen.',
  'privacyPolicy.section9.title': 'IX. Kontaktieren Sie uns',
  'privacyPolicy.section9.intro': 'Wenn Sie Fragen, Kommentare oder Beschwerden zu dieser Datenschutzrichtlinie haben, kontaktieren Sie uns bitte über die folgenden Methoden:',
  'privacyPolicy.section9.email': 'E-Mail: {email}',
  'privacyPolicy.section9.hours': 'Kundenservicezeiten: Werktage 9:00-18:00',
  'privacyPolicy.section9.response': 'Wir werden Ihre Anfrage innerhalb einer angemessenen Zeit beantworten.',
  
  // Nutzungsbedingungen
  'termsOfService.title': 'Nutzungsbedingungen',
  'termsOfService.lastUpdated': 'Zuletzt aktualisiert: {date}',
  'termsOfService.intro': 'Bitte lesen Sie diese Nutzungsbedingungen sorgfältig durch, bevor Sie unsere Dienste nutzen. Durch den Zugriff auf oder die Nutzung der AIMATEX-Plattform (im Folgenden "diese Plattform" oder "Dienst") stimmen Sie zu, an diese Nutzungsbedingungen gebunden zu sein. Wenn Sie mit einem Teil dieser Nutzungsbedingungen nicht einverstanden sind, verwenden Sie bitte unsere Dienste nicht.',
  'termsOfService.section1.title': 'I. Definitionen und Auslegung',
  'termsOfService.section1.1.title': '1.1 Definitionen',
  'termsOfService.section1.1.intro': 'In diesen Nutzungsbedingungen haben, sofern der Kontext nichts anderes erfordert, die folgenden Begriffe die folgenden Bedeutungen:',
  'termsOfService.section1.1.item1.label': '"Plattform" oder "Diese Plattform"',
  'termsOfService.section1.1.item1.desc': 'Bezieht sich auf die AIMATEX-Videogenerierungsdienstplattform, einschließlich, aber nicht beschränkt auf Websites, mobile Anwendungen und verwandte Dienste.',
  'termsOfService.section1.1.item2.label': '"Wir", "Uns", "Unternehmen"',
  'termsOfService.section1.1.item2.desc': 'Bezieht sich auf den Betreiber der AIMATEX-Plattform, nämlich ProTX Team.',
  'termsOfService.section1.1.item3.label': '"Sie", "Benutzer"',
  'termsOfService.section1.1.item3.desc': 'Bezieht sich auf jede Person, Firma oder andere juristische Person, die auf diesen Dienst zugreift oder ihn nutzt.',
  'termsOfService.section1.1.item4.label': '"Dienst"',
  'termsOfService.section1.1.item4.desc': 'Bezieht sich auf alle Funktionen und Dienste, die von dieser Plattform bereitgestellt werden, einschließlich, aber nicht beschränkt auf KI-Video-, Musik-, Bild-, 3D-Modellgenerierung und andere Inhalte, Modellauswahl, Werkverwaltung, Benutzerkontoverwaltung usw.',
  'termsOfService.section1.1.item5.label': '"Inhalt"',
  'termsOfService.section1.1.item5.desc': 'Bezieht sich auf alle Texte, Bilder, Videos, Audiodateien und andere Materialien, die von Benutzern über diese Plattform hochgeladen, generiert, erstellt oder geteilt werden.',
  'termsOfService.section1.1.item6.label': '"Generierter Inhalt"',
  'termsOfService.section1.1.item6.desc': 'Bezieht sich auf Videos, Musik, Bilder, 3D-Modelle und andere Werke, die von Benutzern unter Verwendung der KI-Modelle dieser Plattform generiert werden.',
  'termsOfService.section1.1.item7.label': '"Konto"',
  'termsOfService.section1.1.item7.desc': 'Bezieht sich auf das von Benutzern auf dieser Plattform registrierte Benutzerkonto.',
  'termsOfService.section2.title': 'II. Dienstbeschreibung',
  'termsOfService.section2.1.title': '2.1 Dienstinhalt',
  'termsOfService.section2.1.intro': 'Diese Plattform bietet umfassende KI-Inhaltsgenerierungsdienste, einschließlich, aber nicht beschränkt auf:',
  'termsOfService.section2.1.item1': 'Text-zu-Medien-Generierung (Videos, Musik, Bilder, 3D-Modelle usw.) (Text-to-Media)',
  'termsOfService.section2.1.item2': 'Bild-zu-Medien-Generierung (Videos, 3D-Modelle usw.) (Image-to-Media)',
  'termsOfService.section2.1.item3': 'Verwaltung und Anzeige verschiedener generierter Werke',
  'termsOfService.section2.1.item4': 'Modellauswahl und -verwaltung',
  'termsOfService.section2.1.item5': 'Benutzerkonten und persönliches Zentrum',
  'termsOfService.section2.1.item6': 'Abonnement- und Zahlungsdienste',
  'termsOfService.section2.2.title': '2.2 Dienständerungen',
  'termsOfService.section2.2.content': 'Wir behalten uns das Recht vor, Teile oder den gesamten Dienst jederzeit ohne vorherige Ankündigung zu ändern, auszusetzen oder zu beenden. Wir übernehmen keine Verantwortung für Verluste, die durch Dienständerungen entstehen.',
  'termsOfService.section3.title': 'III. Benutzerkonten',
  'termsOfService.section3.1.title': '3.1 Kontoregistrierung',
  'termsOfService.section3.1.intro': 'Die Nutzung dieses Dienstes erfordert eine Kontoregistrierung. Bei der Registrierung stimmen Sie zu:',
  'termsOfService.section3.1.item1': 'Wahre, genaue und vollständige Registrierungsinformationen bereitzustellen',
  'termsOfService.section3.1.item2': 'Registrierungsinformationen rechtzeitig zu aktualisieren, um sie wahr, genau und vollständig zu halten',
  'termsOfService.section3.1.item3': 'Verantwortlich für alle Aktivitäten unter Ihrem Konto zu sein',
  'termsOfService.section3.1.item4': 'Ihr Kontopasswort sicher aufzubewahren und Ihr Konto nicht an andere zu übertragen, zu verkaufen oder zu verleihen',
  'termsOfService.section3.2.title': '3.2 Altersbeschränkung',
  'termsOfService.section3.2.content': 'Sie müssen mindestens 18 Jahre alt sein, um diesen Dienst zu nutzen. Wenn Sie unter 18 Jahre alt sind, verwenden Sie bitte diesen Dienst mit Zustimmung und unter Aufsicht Ihres Erziehungsberechtigten.',
  'termsOfService.section3.3.title': '3.3 Kontosicherheit',
  'termsOfService.section3.3.content': 'Sie sind dafür verantwortlich, die Sicherheit Ihres Kontos aufrechtzuerhalten. Wenn Sie feststellen, dass Ihr Konto kompromittiert wurde oder eine Sicherheitslücke besteht, benachrichtigen Sie uns bitte sofort. Wir übernehmen keine Verantwortung für Verluste, die durch Ihr Versäumnis entstehen, Ihre Kontoinformationen ordnungsgemäß zu schützen.',
  'termsOfService.section4.title': 'IV. Nutzungsrichtlinien',
  'termsOfService.section4.1.title': '4.1 Verbotene Aktivitäten',
  'termsOfService.section4.1.intro': 'Bei der Nutzung dieses Dienstes dürfen Sie nicht:',
  'termsOfService.section4.1.item1': 'Illegale, schädliche, bedrohliche, beleidigende, belästigende, diffamierende, vulgäre, obszöne, die Privatsphäre oder geistige Eigentumsrechte anderer verletzende Inhalte generieren, hochladen oder teilen',
  'termsOfService.section4.1.item2': 'Falsche Informationen, irreführende Inhalte oder bösartige Inhalte generieren oder verbreiten',
  'termsOfService.section4.1.item3': 'Diesen Dienst für kommerziellen Betrug, Geldwäsche oder andere illegale Aktivitäten nutzen',
  'termsOfService.section4.1.item4': 'Den normalen Betrieb dieser Plattform stören oder zerstören, einschließlich, aber nicht beschränkt auf die Verwendung automatisierter Tools, Crawler, Viren usw.',
  'termsOfService.section4.1.item5': 'Unbefugten Zugriff auf Systeme, Daten oder Konten dieser Plattform erlangen',
  'termsOfService.section4.1.item6': 'Einen Teil dieser Plattform kopieren, modifizieren, verteilen, verkaufen oder vermieten',
  'termsOfService.section4.1.item7': 'Software dieser Plattform reverse engineerieren, dekompilieren oder disassemblieren',
  'termsOfService.section4.2.title': '4.2 Inhaltsverantwortung',
  'termsOfService.section4.2.content': 'Sie tragen die volle Verantwortung für alle Inhalte, die über diese Plattform generiert, hochgeladen oder geteilt werden. Wir überprüfen den von Benutzern generierten Inhalt nicht im Voraus, behalten uns jedoch das Recht vor, verletzende Inhalte jederzeit zu löschen.',
  'termsOfService.section5.title': 'V. Geistiges Eigentum',
  'termsOfService.section5.1.title': '5.1 Geistiges Eigentum der Plattform',
  'termsOfService.section5.1.content': 'Alle Rechte des geistigen Eigentums dieser Plattform, einschließlich, aber nicht beschränkt auf Marken, Patente, Urheberrechte, Geschäftsgeheimnisse usw., gehören uns oder den entsprechenden Rechteinhabern. Sie dürfen sie nicht ohne Genehmigung verwenden.',
  'termsOfService.section5.2.title': '5.2 Von Benutzern generierte Inhalte',
  'termsOfService.section5.2.content': 'Die Rechte des geistigen Eigentums an Inhalten, die Sie über diese Plattform generieren, gehören Ihnen. Sie gewähren uns jedoch ein nicht-exklusives, weltweites, kostenloses und unterlizenzierbares Recht, Ihren Inhalt zu verwenden, anzuzeigen und zu verteilen, um Dienste bereitzustellen und zu verbessern.',
  'termsOfService.section5.3.title': '5.3 KI-Modelle',
  'termsOfService.section5.3.content': 'Die Rechte des geistigen Eigentums an KI-Modellen (einschließlich Sora-Modelle), die von dieser Plattform verwendet werden, gehören ihren Entwicklern. Sie dürfen diese Modelle nicht kopieren, modifizieren oder verteilen.',
  'termsOfService.section6.title': 'VI. Bezahlte Dienste',
  'termsOfService.section6.1.title': '6.1 Zahlungsmodelle',
  'termsOfService.section6.1.content': 'Diese Plattform bietet zwei Zahlungsmodelle: Abonnement und Pay-per-Use. Spezifische Preise und Abrechnungsmethoden unterliegen den Ankündigungen der Plattform.',
  'termsOfService.section6.2.title': '6.2 Zahlung',
  'termsOfService.section6.2.content': 'Sie stimmen zu, die Dienstgebühren gemäß den von der Plattform angekündigten Preisen zu zahlen. Alle Gebühren werden in RMB oder anderen von der Plattform unterstützten Währungen berechnet. Nach erfolgreicher Zahlung sind die Gebühren nicht erstattungsfähig, es sei denn, gesetzlich anders vorgeschrieben oder wir haben andere Zusagen gemacht.',
  'termsOfService.section6.3.title': '6.3 Rückerstattungsrichtlinie',
  'termsOfService.section6.3.content': 'Sofern gesetzlich nicht anders vorgeschrieben oder wir keine anderen Zusagen gemacht haben, sind gezahlte Gebühren nicht erstattungsfähig. Wenn der Dienst aufgrund von Plattformproblemen nicht normal genutzt werden kann, erstatten oder entschädigen wir je nach tatsächlicher Situation.',
  'termsOfService.section7.title': 'VII. Dienstverfügbarkeit',
  'termsOfService.section7.1.title': '7.1 Dienstunterbrechung',
  'termsOfService.section7.1.intro': 'Wir übernehmen keine Verantwortung für Dienstunterbrechungen, die durch folgende Gründe verursacht werden:',
  'termsOfService.section7.1.item1': 'Systemwartung, -upgrade oder -ausfall',
  'termsOfService.section7.1.item2': 'Höhere Gewalt (wie Naturkatastrophen, Kriege, Streiks usw.)',
  'termsOfService.section7.1.item3': 'Probleme mit Drittanbieter-Dienstleistern',
  'termsOfService.section7.1.item4': 'Netzwerkausfälle oder Benutzergeräteprobleme',
  'termsOfService.section7.2.title': '7.2 Dienstgarantie',
  'termsOfService.section7.2.content': 'Wir bemühen uns, die Stabilität und Verfügbarkeit des Dienstes sicherzustellen, garantieren jedoch nicht, dass der Dienst nicht unterbrochen wird, fehlerfrei oder vollständig sicher ist. Der Dienst wird "wie besehen" und "wie verfügbar" bereitgestellt, ohne ausdrückliche oder stillschweigende Garantien.',
  'termsOfService.section8.title': 'VIII. Datenschutz',
  'termsOfService.section8.content': 'Wir legen großen Wert auf den Schutz Ihrer Privatsphäre. Informationen darüber, wie wir Ihre persönlichen Informationen sammeln, verwenden und schützen, finden Sie in unserer Datenschutzrichtlinie. Die Nutzung dieses Dienstes bedeutet Ihre Zustimmung zu unserer Datenschutzrichtlinie.',
  'termsOfService.section9.title': 'IX. Haftungsbeschränkung',
  'termsOfService.section9.1.title': '9.1 Haftungsbereich',
  'termsOfService.section9.1.intro': 'Im gesetzlich zulässigen Höchstmaß übernehmen wir keine Haftung für direkte, indirekte, zufällige, besondere oder Folgeschäden, die durch die Nutzung oder Unmöglichkeit der Nutzung dieses Dienstes entstehen, einschließlich, aber nicht beschränkt auf:',
  'termsOfService.section9.1.item1': 'Gewinnverlust, Datenverlust oder andere wirtschaftliche Verluste',
  'termsOfService.section9.1.item2': 'Geschäftsunterbrechung',
  'termsOfService.section9.1.item3': 'Körperverletzung oder Sachschaden',
  'termsOfService.section9.1.item4': 'Datenschutzverletzung',
  'termsOfService.section9.2.title': '9.2 Haftungsobergrenze',
  'termsOfService.section9.2.content': 'Unsere Gesamthaftung übersteigt nicht den Gesamtbetrag, den Sie in den letzten 12 Monaten tatsächlich für diesen Dienst gezahlt haben, oder 100 US-Dollar (je nachdem, welcher Betrag höher ist).',
  'termsOfService.section10.title': 'X. Dienstkündigung',
  'termsOfService.section10.1.title': '10.1 Kündigung durch Benutzer',
  'termsOfService.section10.1.content': 'Sie können die Nutzung dieses Dienstes jederzeit beenden und Ihr Konto kündigen.',
  'termsOfService.section10.2.title': '10.2 Kündigung durch Plattform',
  'termsOfService.section10.2.intro': 'Wir haben das Recht, Ihr Konto und den Dienst in folgenden Fällen sofort zu kündigen oder zu sperren:',
  'termsOfService.section10.2.item1': 'Sie verletzen diese Nutzungsbedingungen',
  'termsOfService.section10.2.item2': 'Sie betreiben illegale Aktivitäten',
  'termsOfService.section10.2.item3': 'Ihr Konto wurde über einen längeren Zeitraum nicht genutzt',
  'termsOfService.section10.2.item4': 'Rechtliche oder regulatorische Anforderungen',
  'termsOfService.section10.2.note': 'Nach der Dienstkündigung können Sie nicht mehr auf Ihr Konto und generierte Inhalte zugreifen, es sei denn, gesetzlich anders vorgeschrieben.',
  'termsOfService.section11.title': 'XI. Streitbeilegung',
  'termsOfService.section11.1.title': '11.1 Verhandlung',
  'termsOfService.section11.1.content': 'Bei Streitigkeiten sollten beide Parteien zunächst versuchen, diese durch freundliche Verhandlungen zu lösen.',
  'termsOfService.section11.2.title': '11.2 Anwendbares Recht',
  'termsOfService.section11.2.content': 'Diese Nutzungsbedingungen unterliegen den Gesetzen der Volksrepublik China. Wenn beide Parteien den Streit nicht durch Verhandlungen lösen können, wird er einem Volksgericht mit Zuständigkeit an unserem Standort vorgelegt.',
  'termsOfService.section12.title': 'XII. Sonstige Bestimmungen',
  'termsOfService.section12.1.title': '12.1 Änderung der Bedingungen',
  'termsOfService.section12.1.content': 'Wir behalten uns das Recht vor, diese Nutzungsbedingungen jederzeit zu ändern. Wesentliche Änderungen werden Ihnen mindestens 30 Tage vor Inkrafttreten mitgeteilt. Die fortgesetzte Nutzung des Dienstes bedeutet Ihre Zustimmung zu den geänderten Bedingungen.',
  'termsOfService.section12.2.title': '12.2 Teilbarkeit',
  'termsOfService.section12.2.content': 'Wenn eine Bestimmung dieser Nutzungsbedingungen als ungültig oder nicht durchsetzbar erachtet wird, beeinträchtigt dies nicht die Gültigkeit der anderen Bestimmungen.',
  'termsOfService.section12.3.title': '12.3 Vollständige Vereinbarung',
  'termsOfService.section12.3.content': 'Diese Nutzungsbedingungen bilden die vollständige Vereinbarung zwischen Ihnen und uns bezüglich der Nutzung dieses Dienstes und ersetzen alle vorherigen mündlichen oder schriftlichen Vereinbarungen.',
  'termsOfService.section13.title': 'XIII. Kontaktieren Sie uns',
  'termsOfService.section13.intro': 'Wenn Sie Fragen zu diesen Nutzungsbedingungen haben, kontaktieren Sie uns bitte über die folgenden Methoden:',
  'termsOfService.section13.email': 'E-Mail: {email}',
  'termsOfService.section13.hours': 'Kundenservicezeiten: Werktage 9:00-18:00',
  
  // Footer
  'footer.brand.description': 'Bietet KI-Generierungsdienste an.',
  'footer.joinUs': 'Karriere',
  'footer.product.title': 'Produkt',
  'footer.product.signup': 'Registrieren',
  'footer.product.login': 'Anmelden',
  'footer.product.workspace': 'Arbeitsbereich',
  'footer.product.works': 'Meine Werke',
  'footer.support.title': 'Support',
  'footer.support.help': 'Hilfezentrum',
  'footer.support.about': 'Über uns',
  'footer.support.feedback': 'Feedback',
  'footer.support.contact': 'Kontaktieren Sie uns',
  'footer.legal.title': 'Rechtliches',
  'footer.legal.privacy': 'Datenschutzrichtlinie',
  'footer.legal.terms': 'Nutzungsbedingungen',
  'footer.legal.recharge': 'Aufladevereinbarung',
  'footer.resources.title': 'Ressourcen',
  'footer.resources.invite': 'Freunde einladen',
  'footer.resources.account': 'Kontoverwaltung',
  'footer.resources.orders': 'Bestellzentrum',
  'footer.copyright': '© {year} {brand}. Alle Rechte vorbehalten.',
  'footer.description': 'Diese Plattform bietet KI-Generierungsdienste an',
  'footer.openRobotX.title': 'Open Robot X',
  'footer.openRobotX.description': 'Globale Humanoid-Robotik-Datenbank mit Spezifikationsvergleich und Brancheneinblicken',
  'footer.openRobotX.visit': 'Open Robot X besuchen',
  'footer.ai2obj.title': 'ai2obj',
  'footer.ai2obj.description': 'KI-gestützte umfassende Generierungsplattform zur Erstellung vielfältiger digitaler Inhalte',
  'footer.aimatexMusic.title': 'AIMATEX-MUSIC',
  'footer.aimatexMusic.description': 'Persönliche Cloud-Musik: Entdecken, Playlists, Now Playing und Bibliothek',
  
  // Preisgestaltungsseite
  'pricing.title': 'Wählen Sie den Plan, der zu Ihnen passt',
  'pricing.plan.basic.sub': 'Basis',
  'pricing.plan.pro.sub': 'Pro',
  'pricing.plan.team.sub': 'Team',
  'pricing.plan.popular': 'BELIEBT',
  'pricing.plan.button.select': 'Diesen Plan wählen',
  'pricing.plan.button.subscribe': 'Jetzt abonnieren',
  'pricing.plan.basic.videoQuota': '5/Monat',
  'pricing.plan.basic.videoDuration': '6-10s',
  'pricing.plan.basic.videoQuality': '720P',
  'pricing.plan.pro.videoQuota': '30/Monat',
  'pricing.plan.pro.videoDuration': '10-15s',
  'pricing.plan.pro.videoQuality': '1080P',
  'pricing.plan.team.videoQuota': '100/Monat',
  'pricing.plan.team.videoDuration': '10-15s',
  'pricing.plan.team.videoQuality': '1080P/4K',
  'pricing.feature.videoQuota': 'Video-Generierungsquote',
  'pricing.feature.videoDuration': 'Videolänge',
  'pricing.feature.videoQuality': 'Videoqualität',
  'pricing.feature.storyboard': 'Storyboard',
  'pricing.feature.workflow': 'Workflow',
  'pricing.feature.priorityQueue': 'Prioritätswarteschlange',
  'pricing.feature.exclusiveChannel': 'Exklusiver Kanal',
  'pricing.feature.highestQuality': 'Höchste Qualitätsmodus',
  'pricing.feature.sdImage': 'SD-Bildgenerierung',
  'pricing.feature.unlimited': 'Unbegrenzt',
  'pricing.feature.promptOptimization': 'Prompt-Optimierung',
  'pricing.feature.imageSize': 'Bildgröße',
  'pricing.feature.storage': 'Speicherplatz',
  'pricing.feature.commercialLicense': 'Kommerzielle Lizenz',
  'pricing.feature.apiAccess': 'API-Zugriff',
  'pricing.then': 'dann',
  'cta.title': 'Beginnen Sie mit der Erstellung Ihrer Videos',
  'cta.description': 'Registrieren Sie sich jetzt und verwandeln Sie Ihre Kreativität mit KI-Technologie in atemberaubende Videowerke',
  'cta.button': 'Kostenlos starten',
  'technology.coreArchitecture': 'KERNARCHITEKTUR',
  'technology.workflowEngine.title': 'Visueller Workflow-Engine',
  'technology.workflowEngine.description': 'Visuelle Workflow-Unterstützung kommt bald. Jeder Knoten ist eine präzise Kontrolle über Kreativität.',
  'technology.node.checkpointLoader': 'Checkpoint Loader',
  'technology.node.clipTextPositive': 'CLIP Text (Positive)',
  'technology.node.clipTextNegative': 'CLIP Text (Negative)',
  'technology.node.ksamplerAdvanced': 'KSampler Advanced',
  'technology.node.vaeDecode': 'VAE Decode',
  'technology.node.previewImage': 'Preview Image',
  'technology.hud.systemResourceMonitor': 'Systemressourcen-Monitor',
  'technology.hud.gpuVram': 'GPU VRAM',
  'technology.terminal.console': 'console — zsh',
  'technology.button.runWorkflow': 'Workflow ausführen',
  'technology.button.running': 'Wird ausgeführt...',
  'technology.log.systemInitialized': '> System initialisiert.',
  'technology.log.waitingForInput': '> Warten auf Benutzereingabe...',
  'technology.log.loadingCheckpoint': 'Loading SDXL Checkpoint (fp16)...',
  'technology.log.tokenizingPrompt': 'Tokenizing positive prompt...',
  'technology.log.ksamplerSteps': 'KSampler: 30/30 steps (Euler A)',
  'technology.log.generationComplete': 'Generation complete.',
  'technology.benchmark.title': 'Ultimativer Leistungs-Benchmark',
  'technology.benchmark.description': 'Für diese 0,5 Sekunden Verbesserung haben wir 30% der zugrunde liegenden Operatoren neu geschrieben.',
  'technology.benchmark.fps.title': 'Generierungsgeschwindigkeit (FPS)',
  'technology.benchmark.fps.subtitle': 'Comparison @ 1080p',
  'technology.benchmark.vram.title': 'VRAM-Optimierung',
  'technology.benchmark.vram.subtitle': 'Lower is better',
  'technology.benchmark.productX': 'ProductX',
  'technology.benchmark.others': 'Others',
  'technology.benchmark.standard': 'Standard',
  'technology.galaxy.openEcology': 'OFFENE ÖKOLOGIE',
  'technology.galaxy.title': 'Unendliches Modell-Universum',
  'technology.galaxy.description': 'Unterstützung für direkte Civitai-Verbindung, Tausende von Modellen, Ein-Klick-Laden.',
  'technology.galaxy.autoSync': 'Auto-Sync',
  
  // Feedback-Seite
  'feedback.leftPanel.title.line1': 'Wir hören',
  'feedback.leftPanel.title.line2': 'Ihre Stimme',
  'feedback.leftPanel.description': 'Ihr Feedback ist die treibende Kraft hinter der Verbesserung unseres Produkts. Ob Sie einen Fehler gefunden haben oder eine brillante Idee für eine neue Funktion haben, lassen Sie es uns wissen.',
  'feedback.contact.helpDoc.title': 'Hilfedokumentation',
  'feedback.contact.helpDoc.desc': 'FAQ und Benutzerhandbücher durchsuchen',
  'feedback.contact.email.title': 'E-Mail-Support',
  'feedback.contact.service.title': 'Online-Support',
  'feedback.contact.service.hours': 'Werktage 9:00 - 18:00',
  'feedback.type.suggestion.title': 'Funktionsvorschlag',
  'feedback.type.suggestion.desc': 'Ich habe neue Ideen oder Verbesserungsvorschläge',
  'feedback.type.bug.title': 'Fehlerbericht',
  'feedback.type.bug.desc': 'Ich bin auf einen Fehler oder eine Ausnahme gestoßen',
  'feedback.type.question.title': 'Nutzungsanfrage',
  'feedback.type.question.desc': 'Ich verstehe nicht, wie man eine Funktion verwendet',
  'feedback.type.other.title': 'Andere',
  'feedback.type.other.desc': 'Andere Arten von Feedback',
  'feedback.form.type.label': 'Feedback-Typ',
  'feedback.form.title.label': 'Kurze Zusammenfassung',
  'feedback.form.title.placeholder': 'Beschreiben Sie Ihr Problem oder Ihren Vorschlag in einem Satz',
  'feedback.form.title.required': 'Bitte geben Sie einen Titel ein',
  'feedback.form.content.label': 'Detaillierte Beschreibung',
  'feedback.form.content.placeholder': 'Bitte beschreiben Sie den Hintergrund, Reproduktionsschritte oder spezifische Vorschläge...',
  'feedback.form.content.required': 'Bitte geben Sie detaillierte Inhalte ein',
  'feedback.form.attachment.label': 'Anhänge (Optional)',
  'feedback.upload.dragText': 'Klicken Sie oder ziehen Sie Dateien hierher, um sie hochzuladen',
  'feedback.upload.hint': 'Unterstützt JPG, PNG, PDF und andere Formate, einzelne Dateigröße nicht mehr als 5MB',
  'feedback.upload.sizeLimit': 'Die Dateigröße darf 5MB nicht überschreiten',
  'feedback.form.priority.label': 'Priorität',
  'feedback.priority.low.label': 'Niedrig',
  'feedback.priority.low.desc': 'Beeinträchtigt die Nutzung nicht',
  'feedback.priority.medium.label': 'Mittel',
  'feedback.priority.medium.desc': 'Beeinträchtigt die Benutzererfahrung',
  'feedback.priority.high.label': 'Hoch',
  'feedback.priority.high.desc': 'Beeinträchtigt die Nutzung erheblich',
  'feedback.form.contact.label': 'Kontaktinformationen (Optional)',
  'feedback.form.contact.placeholder': 'E-Mail oder Telefonnummer',
  'feedback.form.submit': 'Feedback senden',
  'feedback.submit.error': 'Übermittlung fehlgeschlagen, bitte versuchen Sie es später erneut',
  'feedback.success.title': 'Feedback erhalten!',
  'feedback.success.description': 'Vielen Dank für Ihr wertvolles Feedback. Unser Produktteam wird jedes Feedback sorgfältig lesen. Wenn es sich um einen Fehlerbericht handelt, können wir Sie über die bereitgestellten Kontaktinformationen kontaktieren.',
  'feedback.success.back': 'Zurück',
  'feedback.success.another': 'Weiteres senden',
  // Einladungsseite
  'invite.partnerProgram': 'Partnerprogramm',
  'invite.title.line1': 'Freunde einladen',
  'invite.title.line2': 'Unbegrenzten Wert schaffen',
  'invite.reward.inviter': 'Erhalten Sie {amount} Barprämie für jeden eingeladenen Freund.',
  'invite.reward.invitee': 'Ihr Freund erhält {amount} Willkommensbonus bei der Registrierung.',
  'invite.step1.title': '1. Link teilen',
  'invite.step1.desc': 'Teilen Sie Ihren exklusiven Link über soziale Medien',
  'invite.step2.title': '2. Freund aktiviert',
  'invite.step2.desc': 'Freund schließt Registrierung und Verifizierung ab',
  'invite.step3.title': '3. Einnahmen abheben',
  'invite.step3.desc': 'Sofortige Einnahmen, Auszahlung auf Guthaben',
  'invite.exclusiveCode': 'IHR EXKLUSIVER CODE',
  'invite.copyCode': 'Code kopieren',
  'invite.viewQrcode': 'QR-Code anzeigen',
  'invite.stats.totalInvites': 'Gesamteinladungen',
  'invite.stats.availableReward': 'Verfügbares Guthaben',
  'invite.stats.totalReward': 'Gesamteinnahmen',
  'invite.withdrawNow': 'Jetzt abheben',
  'invite.history.title': 'Einladungsverlauf',
  'invite.filter.all': 'Alle',
  'invite.filter.active': 'Aktiv',
  'invite.filter.pending': 'Ausstehend',
  'invite.status.credited': 'Gutgeschrieben',
  'invite.status.pending': 'Ausstehend',
  'invite.history.empty': 'Keine Einträge',
  'invite.withdraw.title': 'Einnahmen abheben',
  'invite.withdraw.cancel': 'Abbrechen',
  'invite.withdraw.confirm': 'Auszahlung bestätigen',
  'invite.withdraw.amount': 'Auszahlungsbetrag',
  'invite.withdraw.note': '* Der Betrag wird direkt auf Ihr Kontoguthaben überwiesen.',
  'invite.withdraw.enterAmount': 'Bitte Auszahlungsbetrag eingeben',
  'invite.withdraw.insufficientBalance': 'Unzureichendes Guthaben',
  'invite.withdraw.success': '¥{amount} erfolgreich auf Guthaben abgehoben',
  'invite.qrcode.title': 'Scannen zum Beitreten',
  'invite.copyLink': 'Link kopieren',
  'invite.copy.success': 'Erfolgreich kopiert',
  // Homepage Hero-Bereich
  'home.hero.badge': 'KI-Assistent · Begleiter · Partner',
  'home.hero.title': 'AIMATEX',
  'home.hero.subtitle': 'Ihr Klassenkamerad, Seelenverwandter, Teamkollege',
  'home.hero.description': 'AIMATEX ist Ihr KI-Assistent, Lernpartner und kreativer Begleiter. Wir bieten umfassende KI-Lösungen und machen KI zu Ihrem besten Partner in Arbeit, Studium und Kreativität. Ob im Klassenzimmer, bei kreativer Zusammenarbeit oder im Team, AIMATEX ist Ihr vertrauenswürdiger Partner.',
  'home.hero.cta.signup': 'Kostenlos loslegen',
  'home.hero.cta.login': 'Anmelden',
  'home.hero.cta.workspace': 'Zum Arbeitsbereich',
  // Homepage-Produktbereich
  'home.products.title': 'Unsere Produkte',
  'home.products.subtitle': 'Entdecken Sie innovative KI-Produkte von AIMATEX, jedes Produkt ist Ihr bester Partner in verschiedenen Szenarien',
  'home.products.seedance2.name': 'Seedance2',
  'home.products.seedance2.description': 'KI-Bild-zu-Video-Erstellungspartner, der statische Bilder in dynamische Videos verwandelt und Ihre Kreativität zum Leben erweckt',
  'home.products.ai2obj.name': 'AI2Obj',
  'home.products.ai2obj.description': 'KI-gestützte 3D-Objektgenerierungs- und Konvertierungsplattform, Ihr 3D-Erstellungspartner',
  'home.products.openrobotx.name': 'OpenRobotX',
  'home.products.openrobotx.description': 'Erkunden Sie globale humanoide Roboterunternehmen, Parametervergleiche und Brancheneinblicke, Ihr Robotik-Forschungspartner',
  'home.products.openclaw4j.name': 'OpenClaw4j',
  'home.products.openclaw4j.title': 'OpenClaw4j',
  'home.products.openclaw4j.description': 'Autonome-Agenten-Plattform — intelligente Agenten mit OpenForgeX erstellen und bereitstellen.',
  'home.products.openclaw4j.cta': 'Agent ausprobieren',
  'home.products.aimatexMusic.name': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.title': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.description': 'Persönlicher Cloud-Musikraum — Tracks entdecken, kollaborative Playlists, Now Playing und Cloud-Bibliothek',
  'home.products.aimatexMusic.cta': 'Musik öffnen',
  'home.music.eyebrow': 'AIMATEX Suite',
  'home.music.title': 'AIMATEX-MUSIC',
  'home.music.subtitle': 'Ihr persönlicher Cloud-Musikraum — entdecken, sammeln und gemeinsam hören.',
  'home.music.feature.discover.title': 'Entdecken',
  'home.music.feature.discover.desc': 'Tracks suchen und in die Cloud-Bibliothek importieren.',
  'home.music.feature.playlist.title': 'Playlists',
  'home.music.feature.playlist.desc': 'Kollaborative Playlists erstellen und teilen.',
  'home.music.feature.nowPlaying.title': 'Now Playing',
  'home.music.feature.nowPlaying.desc': 'Synchrones Hören, Herzen und Verlauf.',
  'home.music.feature.cloud.title': 'Cloud-Bibliothek',
  'home.music.feature.cloud.desc': 'Hochwertige Audio sicher in der Cloud.',
  'home.music.cta': 'AIMATEX-MUSIC öffnen',
'home.showcase.seedance2.eyebrow': 'Image to Video',
  'home.showcase.seedance2.title': 'Seedance2',
  'home.showcase.seedance2.subtitle': 'Turn still frames into cinematic motion with a next-gen creation engine.',
  'home.showcase.seedance2.f1.title': 'Image to Video',
  'home.showcase.seedance2.f1.desc': 'Upload a photo — AI invents light and motion.',
  'home.showcase.seedance2.f2.title': 'Cinema Quality',
  'home.showcase.seedance2.f2.desc': 'High-res output with stable, crisp detail.',
  'home.showcase.seedance2.f3.title': 'Smart Prompts',
  'home.showcase.seedance2.f3.desc': 'AI polishes rough ideas into film-ready prompts.',
  'home.showcase.seedance2.f4.title': 'Style Switch',
  'home.showcase.seedance2.f4.desc': 'Cyberpunk, oil paint, anime — one click.',
  'home.showcase.seedance2.cta': 'Enter Seedance2',
  'home.showcase.ai2obj.eyebrow': '3D Generation',
  'home.showcase.ai2obj.title': 'AI2Obj',
  'home.showcase.ai2obj.subtitle': 'An AI generation platform that turns ideas into usable digital assets.',
  'home.showcase.ai2obj.f1.title': 'Multimodal',
  'home.showcase.ai2obj.f1.desc': 'From text and images to 3D and content assets.',
  'home.showcase.ai2obj.f2.title': 'Object Convert',
  'home.showcase.ai2obj.f2.desc': 'Structure understanding and format conversion.',
  'home.showcase.ai2obj.f3.title': 'Creator Workflow',
  'home.showcase.ai2obj.f3.desc': 'Pipelines built for product and content teams.',
  'home.showcase.ai2obj.f4.title': 'Cloud Delivery',
  'home.showcase.ai2obj.f4.desc': 'Preview, export, and collaborate in the cloud.',
  'home.showcase.ai2obj.cta': 'Visit AI2Obj',
  'home.showcase.openrobotx.eyebrow': 'Robotics Intel',
  'home.showcase.openrobotx.title': 'OpenRobotX',
  'home.showcase.openrobotx.subtitle': 'Global humanoid robot companies, specs, and industry insights in one place.',
  'home.showcase.openrobotx.f1.title': 'World Map',
  'home.showcase.openrobotx.f1.desc': 'Major humanoid vendors and products covered.',
  'home.showcase.openrobotx.f2.title': 'Spec Compare',
  'home.showcase.openrobotx.f2.desc': 'Clear side-by-side capability and positioning.',
  'home.showcase.openrobotx.f3.title': 'Industry News',
  'home.showcase.openrobotx.f3.desc': 'Funding, launches, and tech movements tracked.',
  'home.showcase.openrobotx.f4.title': 'Research Partner',
  'home.showcase.openrobotx.f4.desc': 'Structured intel for selection and research.',
  'home.showcase.openrobotx.cta': 'Explore OpenRobotX',
  'home.showcase.openclaw4j.eyebrow': 'Autonomous Agents',
  'home.showcase.openclaw4j.title': 'OpenClaw4j',
  'home.showcase.openclaw4j.subtitle': 'Build and deploy intelligent agents with OpenForgeX — make agents run for real.',
  'home.showcase.openclaw4j.f1.title': 'Agent Orchestration',
  'home.showcase.openclaw4j.f1.desc': 'Multi-step planning and execution.',
  'home.showcase.openclaw4j.f2.title': 'Tool Calling',
  'home.showcase.openclaw4j.f2.desc': 'Connect APIs and business systems.',
  'home.showcase.openclaw4j.f3.title': 'Observable Runs',
  'home.showcase.openclaw4j.f3.desc': 'Transparent traces for debug and iteration.',
  'home.showcase.openclaw4j.f4.title': 'One-click Deploy',
  'home.showcase.openclaw4j.f4.desc': 'From prototype to live service fast.',
  'home.showcase.openclaw4j.cta': 'Try Agent',
  'home.products.learnMore': 'Mehr erfahren',
  // Homepage-Funktionsbereich
  'home.features.title': 'All-in-One-Kreativwerkstatt.',
  'home.features.subtitle': 'Mehr als nur Videogenerierung, es ist eine umfassende kreative Ermächtigung.',
  'home.features.aiPrompt.title': 'Können Sie keine Prompts schreiben? KI schreibt für Sie',
  'home.features.aiPrompt.description': 'Völlig ohne Ideen? Lassen Sie die KI mit einem Klick für Sie schreiben. Geben Sie einfach ein paar Wörter ein, die KI verfeinert sie automatisch zu filmreifen Beschreibungen, 10 Sekunden zum Generieren. Möchten Sie den Stil ändern? Klicken Sie erneut, verwandeln Sie sich sofort in Cyberpunk/Ölgemälde/Anime.',
  'home.features.demo.userInput': 'eine Katze',
  'home.features.demo.aiResult': 'Eine elegante Perserkatze mit weichem, flauschigem weißem Langhaar und bernsteinfarbenen Augen, die auf einer sonnenbeschienenen Fensterbank sitzt. Der Hintergrund zeigt einen hellblauen Himmel und wehende weiße Vorhänge. 4K Ultra HD, kinoreife Beleuchtung, Tiefenschärfe, professionelle Fotografie.',
  'home.features.demo.buttonText': 'KI generieren',
  'home.features.demo.buttonLoading': 'Generiert',
  'home.features.demo.thinkingText': 'KI erstellt✨',
  'home.features.quality.title': 'Filmqualität',
  'home.features.quality.description': 'Native Unterstützung für 4K-Auflösung, jedes Bild ist sorgfältig gestaltet.',
  'home.features.imageToVideo.title': 'Bild zu Video',
  'home.features.imageToVideo.description': 'Laden Sie ein statisches Bild hoch, die KI versteht die Beleuchtung und Physik in der Szene, generiert automatisch nachfolgende Dynamik und erweckt Fotos zum Leben.',
  'home.features.multimodal.title': 'Multimodales Ökosystem',
  'home.features.multimodal.description': 'Unterstützt nicht nur Stable Diffusion Text-zu-Bild, sondern integriert auch Midjourney-Stilübertragung und ElevenLabs-Audiosynthese. Vervollständigen Sie alle Kreationen in einem Workflow.',
  
  // Startseite Community-Bereich
  'home.community.title': 'Entdecken Sie AI-Creative-Communities',
  'home.community.subtitle': 'Schließen Sie sich Millionen von Kreativen an, teilen Sie Ihre AI-Meisterwerke und erhalten Sie Inspiration und Feedback',
  'home.community.hot': 'Beliebt',
  'home.community.explore': 'Community erkunden',
  'home.community.stats.works': 'Werke',
  'home.community.stats.creators': 'Kreative',
  'home.community.stats.views': 'Aufrufe',
  'home.community.image.title': 'AI-Bild-Community',
  'home.community.image.description': 'Entdecken und teilen Sie beeindruckende AI-generierte Bilder, von fotorealistisch bis künstlerisch, von Illustrationen bis Fotografie',
  'home.community.video.title': 'AI-Video-Community',
  'home.community.video.description': 'Entdecken Sie erstaunliche AI-generierte Videos, lernen Sie kreative Techniken und tauschen Sie sich mit globalen Video-Kreativen aus',
  'home.community.music.title': 'AI-Musik-Community',
  'home.community.music.description': 'Hören Sie wunderschöne von AI komponierte Melodien, teilen Sie Ihre Musikwerke und finden Sie gleichgesinnte Musikliebhaber',
  'home.community.3d.title': 'AI-3D-Modell-Community',
  'home.community.3d.description': 'Erkunden Sie die Welt der AI-generierten 3D-Modelle, von Architektur bis Charaktere, von Spielen bis Industriedesign',
  'home.community.voice.title': 'AI-Sprach-Community',
  'home.community.voice.description': 'Erleben Sie realistische AI-Sprachsynthese, Synchronisation, Hörbücher, Stimmklonen und erwecken Sie Ihre Kreationen zum Leben',
  'home.community.text.title': 'AI-Text-Community',
  'home.community.text.description': 'Teilen Sie hervorragende AI-erstellte Texte, Romane, Gedichte, Drehbücher, Werbetexte und lassen Sie sich literarisch inspirieren',
  
  // Abrechnungsseite
  'billing.page.title': 'Finanzzentrum',
  'billing.page.description': 'Verwalten Sie Ihre Transaktionen und Abrechnungsdetails',
  'billing.button.refresh': 'Aktualisieren',
  'billing.button.recharge': 'Aufladen',
  'billing.button.reset': 'Zurücksetzen',
  'billing.button.apply': 'Filter anwenden',
  'billing.balance.cny': 'CNY-Guthaben',
  'billing.balance.usdt': 'USDT-Guthaben',
  'billing.balance.usd': 'USD-Guthaben',
  'billing.balance.token': 'Token-Guthaben',
  'billing.balance.frozen': 'Eingefroren',
  'billing.type.frozen': 'Mittel eingefroren',
  'billing.type.aiModelFee': 'KI-Modellgebühr',
  'billing.type.recharge': 'Aufladung',
  'billing.type.refund': 'Rückerstattung',
  'billing.type.reward': 'Belohnung',
  'billing.type.all': 'Alle Typen',
  'billing.coin.all': 'Alle Währungen',
  'billing.coin.usdt': 'USDT',
  'billing.coin.cny': 'CNY',
  'billing.coin.usd': 'USD',
  'billing.coin.token': 'TOKEN',
  'billing.table.type': 'Typ',
  'billing.table.coinType': 'Währung',
  'billing.table.time': 'Zeit',
  'billing.table.amount': 'Betrag',
  'billing.table.remark': 'Bemerkung',
  'billing.table.balance': 'Saldo',
  'billing.table.empty': 'Keine Datensätze',
  'billing.filter.title': 'Filteroptionen',
  'billing.filter.button': 'Filter & Datum',
  'billing.filter.changeType': 'Transaktionstyp',
  'billing.filter.coinType': 'Währungstyp',
  'billing.filter.remark': 'Bemerkungssuche',
  'billing.filter.remarkPlaceholder': 'Suchbegriffe eingeben',
  'billing.filter.remarkSearch': 'Bemerkungssuche',
  'billing.filter.dateQuick': 'Schnelldatum',
  'billing.filter.dateCustom': 'Benutzerdefiniertes Datum',
  'billing.filter.dateTo': 'bis',
  'billing.filter.days7': 'Letzte 7 Tage',
  'billing.filter.days30': 'Letzte 30 Tage',
  'billing.filter.days90': 'Letzte 3 Monate',
  'billing.placeholder.changeType': 'Änderungstyp',
  'billing.placeholder.coinType': 'Währung',
  'billing.placeholder.remark': 'Bemerkungssuche',
  'billing.message.fetchBalanceError': 'Guthaben konnte nicht abgerufen werden',
  'billing.message.fetchRecordsError': 'Abrechnungsdatensätze konnten nicht abgerufen werden',
  'billing.message.tryAgain': 'Abrechnungsdatensätze konnten nicht abgerufen werden, bitte später erneut versuchen',
  
  // Auflade-Seite
  'recharge.page.title': 'Konto aufladen',
  'recharge.page.backLink': 'Zurück zur Abrechnung',
  'recharge.balance.title': 'Kontoguthaben',
  'recharge.balance.refresh': 'Aktualisieren',
  'recharge.section.coinType': 'Aufladen Währung',
  'recharge.section.paymentMethod': 'Zahlungsmethode',
  'recharge.section.amount': 'Aufladebetrag',
  'recharge.order.title': 'Bestelldetails',
  'recharge.order.type': 'Aufladen Typ',
  'recharge.order.typeValue': 'Kontoguthaben aufladen',
  'recharge.order.account': 'Konto',
  'recharge.order.accountLoading': 'Laden...',
  'recharge.order.paymentMethod': 'Zahlungsmethode',
  'recharge.order.paymentMethodPlease': 'Bitte wählen',
  'recharge.order.total': 'Gesamtbetrag',
  'recharge.button.pay': 'Jetzt bezahlen',
  'recharge.button.customize': 'Benutzerdefinierter Betrag',
  'recharge.placeholder.customAmount': 'Benutzerdefinierten Betrag eingeben',
  'recharge.security.ssl': 'SSL-verschlüsselte Übertragung, sichere Zahlung',
  'recharge.security.agreement': 'Durch Klicken auf Bezahlen stimmen Sie zu',
  'recharge.security.agreementLink': 'Auflade-Servicevereinbarung',
  'recharge.empty.noCurrency': 'Keine unterstützten Währungen',
  'recharge.empty.noPaymentMethod': 'Keine Zahlungsmethode verfügbar für {currency}',
  'recharge.empty.pleaseSelectCurrency': 'Bitte wählen Sie zuerst die Währung',
  'recharge.empty.pleaseSelectPayment': 'Bitte wählen Sie zuerst die Zahlungsmethode',
  'recharge.empty.noProducts': 'Keine Produkte verfügbar',
  'recharge.empty.noPresets': 'Keine voreingestellten Beträge für {currency}',
  'recharge.message.invalidAmount': 'Bitte geben Sie einen gültigen Betrag ein',
  'recharge.message.selectPaymentMethod': 'Bitte wählen Sie eine Zahlungsmethode',
  'recharge.message.selectAmount': 'Bitte wählen Sie den Aufladebetrag',
  'recharge.message.fetchBalanceError': 'Guthaben konnte nicht abgerufen werden, bitte später erneut versuchen',
  'recharge.message.fetchUserInfoError': 'Benutzerinformationen konnten nicht abgerufen werden',
  'recharge.message.fetchCurrenciesError': 'Währungen konnten nicht abgerufen werden, bitte später erneut versuchen',
  'recharge.message.fetchPaymentMethodsError': 'Zahlungsmethoden konnten nicht abgerufen werden, bitte später erneut versuchen',
  'recharge.message.fetchCreemProductsError': 'Creem-Produkte konnten nicht abgerufen werden, bitte später erneut versuchen',
  'recharge.message.fetchCreemProductsWarning': 'Creem-Produkte konnten nicht abgerufen werden',
  'recharge.message.orderCreated': 'Bestellung erfolgreich erstellt',
  'recharge.message.orderCreateFailed': 'Auflade-Bestellung konnte nicht erstellt werden',
  'recharge.message.paymentProcessing': 'Zahlungsseite wird geöffnet, bitte schließen Sie die Zahlung ab...',
  'recharge.message.popupBlocked': 'Zahlungsfenster kann nicht geöffnet werden, bitte überprüfen Sie die Browser-Popup-Einstellungen',
  'recharge.message.paymentUrlError': 'Zahlungs-URL konnte nicht abgerufen werden',
  'recharge.message.checkoutSessionError': 'Zahlungssitzung konnte nicht erstellt werden',
  'recharge.message.paymentError': 'Zahlungsverarbeitung fehlgeschlagen, bitte später erneut versuchen',
  'recharge.message.redirecting': 'Weiterleitung zur Zahlungsseite, bitte schließen Sie die Zahlung ab...',
  'recharge.message.paymentUrlFailed': 'Zahlungs-URL nicht verfügbar',
  'recharge.message.paymentSuccess': 'Zahlung erfolgreich! Guthaben aktualisiert',
  'recharge.message.orderCancelled': 'Bestellung storniert',
  'recharge.message.paymentFailed': 'Zahlung fehlgeschlagen',
  'recharge.message.orderExpired': 'Abgelaufen',
  'recharge.message.queryOrderError': 'Bestellstatus konnte nicht abgefragt werden',
  'recharge.message.rechargeError': 'Auflade-Anfrage fehlgeschlagen, bitte später erneut versuchen',

  // Bestellseite
  'orders.title': 'Bestellhistorie',
  'orders.subtitle': 'Alle Ihre Auflade-Bestellungen und deren Status anzeigen',
  'orders.refresh': 'Aktualisieren',
  'orders.goToRecharge': 'Aufladen',

  // Statistikkarten
  'orders.stats.totalOrders': 'Gesamtbestellungen',
  'orders.stats.pending': 'Ausstehend',
  'orders.stats.paid': 'Bezahlt',
  'orders.stats.totalAmount': 'Gesamt aufgeladen',

  // Tabellenspalten
  'orders.table.orderNo': 'Bestellnr.',
  'orders.table.createTime': 'Erstellt am',
  'orders.table.amount': 'Betrag',
  'orders.table.paymentMethod': 'Zahlungsmethode',
  'orders.table.status': 'Status',
  'orders.table.action': 'Aktion',
  'orders.table.view': 'Ansehen',
  'orders.table.cancel': 'Stornieren',
  'orders.table.empty': 'Keine Bestellungen',

  // Bestellstatus
  'orders.status.pending': 'Ausstehend',
  'orders.status.paid': 'Bezahlt',
  'orders.status.success': 'Abgeschlossen',
  'orders.status.cancelled': 'Storniert',
  'orders.status.failed': 'Fehlgeschlagen',
  'orders.status.expired': 'Abgelaufen',
  'orders.status.all': 'Alle Status',

  // Zahlungsmethoden
  'orders.payment.alipay': 'Alipay',
  'orders.payment.wechat': 'WeChat Pay',
  'orders.payment.bank': 'Bankkarte',
  'orders.payment.usdt': 'USDT',
  'orders.payment.creem': 'Creem',
  'orders.payment.all': 'Alle Methoden',

  // Währung
  'orders.coin.all': 'Alle Währungen',

  // Filter
  'orders.filter.title': 'Filteroptionen',
  'orders.filter.button': 'Bestellungen filtern',
  'orders.filter.reset': 'Zurücksetzen',
  'orders.filter.apply': 'Anwenden',
  'orders.filter.orderStatus': 'Bestellstatus',
  'orders.filter.paymentMethod': 'Zahlungsmethode',
  'orders.filter.coinType': 'Währungstyp',
  'orders.filter.orderNoSearch': 'Bestellnr. suchen',
  'orders.filter.quickDate': 'Schnelldatum',
  'orders.filter.customDate': 'Benutzerdefiniertes Datum',
  'orders.filter.dateTo': 'bis',
  'orders.filter.last7Days': 'Letzte 7 Tage',
  'orders.filter.last30Days': 'Letzte 30 Tage',
  'orders.filter.last3Months': 'Letzte 3 Monate',

  // Suche und Eingabe
  'orders.search.placeholder': 'Bestellnummer suchen',
  'orders.input.orderNo': 'Bestellnummer eingeben',
  'orders.select.orderStatus': 'Bestellstatus',
  'orders.select.paymentMethod': 'Zahlungsmethode',
  'orders.select.coinType': 'Währung',

  // Nachrichten
  'orders.message.fetchError': 'Bestellungen konnten nicht abgerufen werden',
  'orders.message.fetchErrorRetry': 'Bestellungen konnten nicht abgerufen werden, bitte später erneut versuchen',
  'orders.message.statsError': 'Statistiken konnten nicht abgerufen werden',
  'orders.message.cancelSuccess': 'Bestellung storniert',
  'orders.message.cancelError': 'Bestellung konnte nicht storniert werden',
  'orders.message.cancelErrorRetry': 'Bestellung konnte nicht storniert werden, bitte später erneut versuchen',
  'orders.message.viewOrder': 'Bestellnr.: {orderNo}',

  // Bestätigungsdialog
  'orders.confirm.cancel': 'Sind Sie sicher, dass Sie diese Bestellung stornieren möchten?',
  'orders.confirm.ok': 'OK',
  'orders.confirm.cancelButton': 'Abbrechen',

  // Karriere-Seite
  'joinUs.seo.title': 'PROTX beitreten - Streben nach Perfektion',
  'joinUs.seo.description': 'Werden Sie Teil des PROTX-Teams und verfolgen Sie mit uns die ultimative Benutzererfahrung und Produktdesign',
  'joinUs.hero.eyebrow': 'JOIN PROTX',
  'joinUs.hero.title': 'Streben nach Perfektion',
  'joinUs.hero.title2': 'Die Zukunft durch Design definieren',
  'joinUs.hero.subtitle': 'PROTX ist ein Team, das sich der Schaffung der ultimativen Benutzererfahrung und des Produktdesigns widmet. Wir glauben, dass jedes Pixel zählt, jede Interaktion sorgfältig poliert werden verdient. Wenn Sie unser unermüdliches Streben nach Exzellenz teilen, schließen Sie sich uns an.',
  'joinUs.hero.cta': 'Offene Stellen ansehen',
  'joinUs.hero.video': 'Unsere Geschichte ansehen',
  
  'joinUs.values.eyebrow': 'UNSERE WERTE',
  'joinUs.values.title': 'Unsere Kernwerte',
  'joinUs.values.subtitle': 'Diese Kernwerte definieren, wer wir sind und wie wir zusammenarbeiten',
  'joinUs.values.innovation.title': 'Innovationsgetrieben',
  'joinUs.values.innovation.desc': 'Wir glauben, dass Innovation die Kraft ist, die die Welt verändert, und fördern jede bahnbrechende Idee.',
  'joinUs.values.collaboration.title': 'Zusammenarbeit',
  'joinUs.values.collaboration.desc': 'Teamübergreifende Zusammenarbeit für außergewöhnliche Ergebnisse.',
  'joinUs.values.excellence.title': 'Streben nach Exzellenz',
  'joinUs.values.excellence.desc': 'Ständig Grenzen überschreiten für das ultimative Erlebnis.',
  'joinUs.values.passion.title': 'Leidenschaft & Fokus',
  'joinUs.values.passion.desc': 'Leidenschaft für Technologie, Hingabe zum Produkt.',
  'joinUs.values.impact.title': 'Wirkung erzielen',
  'joinUs.values.impact.desc': 'Jeden kreativen Ausdruck durch KI-Technologie ermöglichen.',
  
  'joinUs.positions.eyebrow': 'OFFENE STELLEN',
  'joinUs.positions.title': 'Offene Stellen',
  'joinUs.positions.subtitle': 'Finden Sie die Rolle, die zu Ihnen passt, und starten Sie Ihre neue Karrierereise',
  'joinUs.category.engineering': 'Engineering',
  'joinUs.category.product': 'Produkt & Design',
  'joinUs.category.operations': 'Operations & Marketing',
  'joinUs.position.seniorFrontend': 'Senior Frontend-Entwickler',
  'joinUs.position.backendEngineer': 'Backend-Entwickler',
  'joinUs.position.mlEngineer': 'KI/ML-Ingenieur',
  'joinUs.position.productManager': 'Produktmanager',
  'joinUs.position.uxDesigner': 'UX-Designer',
  'joinUs.position.communityManager': 'Community Manager',
  'joinUs.position.contentCreator': 'Content Creator',
  'joinUs.location.remote': 'Remote',
  'joinUs.location.beijing': 'Peking',
  'joinUs.location.shanghai': 'Shanghai',
  'joinUs.location.shenzhen': 'Shenzhen',
  'joinUs.type.fulltime': 'Vollzeit',
  'joinUs.type.parttime': 'Teilzeit',
  
  'joinUs.benefits.eyebrow': 'BENEFITS',
  'joinUs.benefits.title': 'Was wir bieten',
  'joinUs.benefits.subtitle': 'Werden Sie Teil unseres Teams und genießen Sie umfassende Leistungen und Unterstützung',
  'joinUs.benefit.flexible.title': 'Flexible Arbeit',
  'joinUs.benefit.flexible.desc': 'Flexible Arbeitszeiten und Remote-Optionen',
  'joinUs.benefit.equity.title': 'Aktienoptionen',
  'joinUs.benefit.equity.desc': 'Wachsen Sie mit dem Unternehmen und teilen Sie unseren Erfolg',
  'joinUs.benefit.health.title': 'Krankenversicherung',
  'joinUs.benefit.health.desc': 'Umfassende Krankenversicherung und Wellness-Leistungen',
  'joinUs.benefit.growth.title': 'Karriereentwicklung',
  'joinUs.benefit.growth.desc': 'Kontinuierliche Lern- und Entwicklungsmöglichkeiten',
  
  'joinUs.cta.title': 'Bereit anzufangen?',
  'joinUs.cta.subtitle': 'Wenn Sie für unsere Mission brennen, freuen wir uns auf Ihre Bewerbung',
  'joinUs.cta.button': 'Jetzt bewerben',
  
  'joinUs.modal.title': 'Stellenbewerbung',
  'joinUs.apply.success': 'Bewerbung eingereicht! Wir werden uns bald bei Ihnen melden.',
  'joinUs.form.name': 'Name',
  'joinUs.form.name.required': 'Bitte geben Sie Ihren Namen ein',
  'joinUs.form.name.placeholder': 'Geben Sie Ihren Namen ein',
  'joinUs.form.email': 'E-Mail',
  'joinUs.form.email.required': 'Bitte geben Sie Ihre E-Mail ein',
  'joinUs.form.email.invalid': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
  'joinUs.form.email.placeholder': 'Geben Sie Ihre E-Mail ein',
  'joinUs.form.phone': 'Telefonnummer',
  'joinUs.form.phone.placeholder': 'Geben Sie Ihre Telefonnummer ein',
  'joinUs.form.experience': 'Berufserfahrung',
  'joinUs.form.experience.placeholder': 'Wählen Sie Ihre Erfahrungsstufe',
  'joinUs.form.experience.0-2': '0-2 Jahre',
  'joinUs.form.experience.3-5': '3-5 Jahre',
  'joinUs.form.experience.5-10': '5-10 Jahre',
  'joinUs.form.experience.10+': '10+ Jahre',
  'joinUs.form.resume': 'Lebenslauf',
  'joinUs.form.resume.hint': 'Klicken oder Datei hierher ziehen zum Hochladen',
  'joinUs.form.resume.format': 'PDF, DOC, DOCX Formate unterstützt',
  'joinUs.form.message': 'Anschreiben',
  'joinUs.form.message.placeholder': 'Erzählen Sie uns von sich und warum Sie bei uns arbeiten möchten',
  'joinUs.form.submit': 'Bewerbung einreichen',
  'joinUs.form.loginTip': 'Melden Sie sich vor dem Absenden an, um Ihre Bewerbung zu verfolgen',
  'joinUs.form.goLogin': 'Anmelden',
  'joinUs.form.resume.sizeLimit': 'Die Dateigröße darf 10 MB nicht überschreiten',
  
  // Meine Bewerbungen
  'joinUs.myApplications.eyebrow': 'MEINE BEWERBUNGEN',
  'joinUs.myApplications.title': 'Bewerbungsverlauf',
  'joinUs.myApplications.empty': 'Noch keine Bewerbungen. Reichen Sie jetzt Ihren Lebenslauf ein!',
  'joinUs.myApplications.viewDetail': 'Details anzeigen',
  'joinUs.myApplications.detailTitle': 'Bewerbungsdetails',
  'joinUs.status.pending': 'Ausstehend',
  'joinUs.status.reviewing': 'In Prüfung',
  'joinUs.status.interview': 'Vorstellungsgespräch',
  'joinUs.status.accepted': 'Angenommen',
  'joinUs.status.rejected': 'Abgelehnt',
  'joinUs.detail.basicInfo': 'Grundinformationen',
  'joinUs.detail.positionInfo': 'Stelleninformationen',
  'joinUs.detail.position': 'Beworbene Stelle',
  'joinUs.detail.category': 'Kategorie',
  'joinUs.detail.location': 'Standort',
  'joinUs.detail.applyTime': 'Bewerbungsdatum',
  'joinUs.detail.downloadResume': 'Lebenslauf herunterladen',
  'joinUs.detail.status': 'Bewerbungsstatus',

  // About Seite
  'about.hero.title1': 'Open-Source-Kern.',
  'about.hero.title2': 'Unendliche Möglichkeiten.',
  'about.hero.subtitle1': 'Basierend auf',
  'about.hero.subtitle2': 'und',
  'about.hero.subtitle3': 'Ökosystem.',
  'about.hero.description': 'Wir verpacken den modernsten generativen AI-Tech-Stack von 2025 in ein ultimatives interaktives Erlebnis.',
  'about.tech.poweredBy': 'Powered by',
  'about.philosophy.title1': 'Mehr als Generierung.',
  'about.philosophy.title2': 'Dies ist ein vollständiger',
  'about.philosophy.title3': 'Kreativitäts-Engine.',
  'about.philosophy.description': 'Von präziser Kontrolle bei Text-zu-Bild bis hin zur Physiksimulation bei Videogenerierung – wir streben nach den Grenzen der Technologie.',
  'about.bento.comfy.title': 'Präzisionskontrolle auf Knotenebene.',
  'about.bento.comfy.description': 'Basierend auf ComfyUI-Knotenarchitektur mit Unterstützung für ControlNet-Pose-Kontrolle und IP-Adapter-Stiltransfer. Wir kapseln komplexe Knotenlogik in intuitive Schieberegler, sodass jede Generierung genau Ihren Vorstellungen entspricht.',
  'about.bento.opensource.title': 'Open Source umarmen.',
  'about.bento.opensource.description': 'Basierend auf Stable Diffusion 3.5 & XL Turbo. Nicht nur blitzschnelle Generierung, sondern auch massive Community-LoRA-Modellunterstützung.',
  'about.bento.video.title': 'DiT-Video-Architektur.',
  'about.bento.video.description': 'Einführung von Diffusion Transformer (DiT) mit räumlich-zeitlichem Aufmerksamkeitsmechanismus für SORA-Level physikalische Weltsimulation.',
  'about.bento.audio.title': 'Audio-visuelle Synchronisation, sensorisches Erwachen.',
  'about.bento.audio.description': 'Mehr als nur visuell. Integriert mit den neuesten Audiogenerierungsmodellen, unterstützt Text-to-Audio und automatische Videoausrichtung. Von Sehen zu Hören – ein vollständiges immersives Erlebnis.',
  'about.techSection.title': 'Technische Architektur.',
  'about.techSection.description': 'Tauchen Sie tief in den Kern-Engine ein, der ProductX antreibt.',
  'about.techCard.sd.title': 'Das Fundament generativer Kunst.',
  'about.techCard.sd.description': 'Wir integrieren die neuesten Stable Diffusion-Generierungsmodelle tief. Durch benutzerdefinierte VAE und optimierte Sampler erreichen wir 300% schnellere Generierung bei gleichbleibend exquisiter Bildqualität.',
  'about.techCard.spec.baseModel': 'Basismodell',
  'about.techCard.spec.resolution': 'Auflösung',
  'about.techCard.spec.resolution.value': 'Bis zu 4K Upscaling',
  'about.techCard.spec.control': 'Kontrolle',
  'about.techCard.spec.speed': 'Geschwindigkeit',
  'about.techCard.spec.speed.value': '< 1s (Turbo-Modus)',
  'about.techCard.video.title': 'Video-Physik-Engine der nächsten Generation.',
  'about.techCard.video.description': 'Wir verlassen die traditionelle 2D-Animationslogik und übernehmen die neueste DiT (Diffusion Transformer)-Architektur von 2025. Das Modell versteht Beleuchtung, Schwerkraft und Bewegungsphysik und generiert nicht nur Videos, sondern physikalisch akkurate dynamische Welten.',
  'about.techCard.spec.architecture': 'Architektur',
  'about.techCard.spec.frameRate': 'Bildrate',
  'about.techCard.spec.frameRate.value': '24 / 60 FPS Interpolation',
  'about.techCard.spec.consistency': 'Konsistenz',
  'about.techCard.spec.consistency.value': 'Hohe zeitliche Stabilität',
  'about.techCard.spec.length': 'Länge',
  'about.techCard.spec.length.value': 'Unendliche Schleifenerweiterung',
  'about.techCard.img2img.title': 'Bild-zu-Bild & Stiltransfer.',
  'about.techCard.img2img.description': 'Mit IP-Adapter und T2I-Adapter-Technologien erreichen wir Zero-Shot-Stiltransfer. Laden Sie ein Referenzbild hoch, um sofort Komposition, Beleuchtung und Kunststil zu replizieren und unendliche kreative Möglichkeiten freizusetzen.',
  'about.techCard.spec.technology': 'Technologie',
  'about.techCard.spec.precision': 'Präzision',
  'about.techCard.spec.precision.value': 'Pixelgenaues Inpainting',
  'about.cta.title': 'Bereit, die Zukunft zu erleben?',
  'about.cta.description': 'Schließen Sie sich den professionellen Kreativen an und entfesseln Sie das ultimative Potenzial der KI.',
  'about.cta.button.start': 'Jetzt starten',
  'about.cta.button.docs': 'Dokumentation lesen',
  
  // Community
  'community.explore.title': 'Communities erkunden',
  'community.explore.subtitle': 'Entdecken Sie Inspiration, remixen Sie Workflows und verbinden Sie sich mit Tausenden von KI-Kreativen.',
  'community.posts': '{count} Beiträge',
  'community.empty': 'Keine Community-Kanäle',
  'community.loadFailed': 'Laden fehlgeschlagen',
  'community.noPosts': 'Noch keine Beiträge',
  'community.challenge.loadFailed': 'Fehler beim Laden der Challenge-Daten',
  
  'common.loadFailed': 'Laden fehlgeschlagen',
  'common.operationFailed': 'Vorgang fehlgeschlagen',
  'common.error': 'Vorgang fehlgeschlagen',
  'common.publish': 'Veröffentlichen',
  'common.back': 'Zurück',
  'common.backToCommunity': 'Zurück zur Community',
  'common.copy': 'Kopieren',
  'common.copied': 'Kopiert',
  'common.follow': 'Folgen',
  'common.processing': 'Verarbeitung...',
  'common.viewCount': '{count} Aufrufe',
  'common.loadMore': 'Mehr laden',
  'common.search': 'Suchen...',
  'common.notFound': 'Nicht gefunden',
  'common.description': 'Beschreibung',
  
  'user.followSuccess': 'Erfolgreich gefolgt',
  'user.unfollowSuccess': 'Erfolgreich entfolgt',
  'user.following': 'Folge',
  'user.mutual_follow': 'Gegenseitig',
  
  'post.untitled': 'Unbenanntes Werk',
  'post.prompt': 'Eingabeaufforderung',
  'post.negativePrompt': 'Negative Eingabeaufforderung',
  'post.details': 'Details',
  'post.model': 'Modell',
  'post.resolution': 'Auflösung',
  'post.steps': 'Schritte',
  'post.cfgScale': 'Führungsskala',
  'post.remix': 'Remix / Dies ausprobieren',
  
  'challenge.status.upcoming': 'Bevorstehend',
  'challenge.status.live': 'Läuft',
  'challenge.status.voting': 'Abstimmung',
  'challenge.status.ended': 'Beendet',
  'challenge.status.unknown': 'Unbekannt',
  'challenge.allChallenges': 'Alle Challenges',
  'challenge.entriesCount': '{count} Beiträge',
  'challenge.tab.submissions': 'Einreichungen',
  'challenge.tab.rules': 'Regeln & Infos',
  'challenge.requirements': 'Anforderungen',
  'challenge.req.original': 'Nur originale Kreationen.',
  'challenge.req.model': 'Muss Modell verwenden: {model}',
  'challenge.req.tags': 'Muss Tags enthalten:',
  'challenge.req.resolution': 'Auflösung muss mindestens 1024x1024 sein.',
  'challenge.req.nsfw': 'Keine NSFW-Inhalte.',
  'challenge.timeRemaining': 'Verbleibende Zeit',
  'challenge.startsIn': 'Beginnt in',
  'challenge.notStarted': 'Challenge noch nicht gestartet',
  'challenge.closed': 'Challenge geschlossen',
  'challenge.submitEntry': 'Beitrag einreichen',
  'challenge.viewWinners': 'Gewinner ansehen',
  'challenge.readRulesTip': 'Lesen Sie die Regeln vor der Einreichung',
  'challenge.prizePool': 'Preispool',
  'challenge.totalValue': 'Gesamtwert',
  'challenge.rank.1st': '1. Platz',
  'challenge.rank.2nd': '2. Platz',
  'challenge.rank.3rd': '3. Platz',
  'challenge.share': 'Challenge teilen',
  'challenge.noEntries': 'Noch keine Beiträge. Seien Sie der Erste!',
  'challenge.noChallenges': 'Keine Challenges gefunden',
  // MediaTools
  'mediaTools.tab.imageCompress': 'Bildkomprimierung',
  'mediaTools.tab.videoCompress': 'Videokomprimierung',
  'mediaTools.tab.audioCompress': 'Audiokomprimierung',
  'mediaTools.tab.formatConvert': 'Formatkonvertierung',
  // ImageCompress
  'imageCompress.title': 'Professionelles Bildkomprimierungs-Tool',
  'imageCompress.subtitle': 'Intelligente Komprimierung, professionelle Qualität',
  'imageCompress.upload': 'Bilder hochladen',
  'imageCompress.addImages': 'Bilder hinzufügen',
  'imageCompress.uploadToStart': 'Bilder hochladen, um mit der Komprimierung zu beginnen',
  'imageCompress.settings': 'Einstellungen',
  'imageCompress.clearAll': 'Alles löschen',
  'imageCompress.totalSavings': 'Ersparnisse',
  'imageCompress.totalSize': 'Gesamtgröße',
  'imageCompress.quality': 'Qualität',
  'imageCompress.resize': 'Größe ändern',
  'imageCompress.scalePercent': 'Skalierung %',
  'imageCompress.customPx': 'Benutzerdefinierte px',
  'imageCompress.presetSize': 'Voreingestellte Größe',
  'imageCompress.width': 'Breite',
  'imageCompress.height': 'Höhe',
  'imageCompress.format': 'Format',
  'imageCompress.format.auto': 'Auto (Original)',
  'imageCompress.format.jpeg': 'JPEG (Foto)',
  'imageCompress.format.png': 'PNG (Verlustfrei)',
  'imageCompress.format.webp': 'WebP (Beste)',
  'imageCompress.pngLossless': 'PNG ist verlustfrei. Qualitätsschieberegler ist ausgeblendet.',
  'imageCompress.cacheSettings': 'Cache-Einstellungen',
  'imageCompress.cacheTooltip': 'Wenn aktiviert, werden hochgeladene Bilder im Browser-Cache gespeichert und nach dem Neuladen der Seite wiederhergestellt.',
  'imageCompress.saveToCache': 'Bilder im Browser-Cache speichern',
  'imageCompress.batchProcessing': 'Batch-Verarbeitung',
  'imageCompress.batchTooltip': 'Wenn aktiviert, wird die Komprimierung mit den aktuellen Einstellungen auf alle {count} Bilder angewendet.',
  'imageCompress.applyToAll': 'Einstellungen auf alle Bilder anwenden ({count})',
  'imageCompress.compress': 'Anwenden und komprimieren',
  'imageCompress.compressAll': 'Alle anwenden und komprimieren ({count})',
  'imageCompress.compressing': 'Wird komprimiert...',
  'imageCompress.compressAllProgress': '{count} Bilder werden komprimiert...',
  'imageCompress.download': 'Bild herunterladen',
  'imageCompress.downloadAll': 'Alle herunterladen ({count})',
  'imageCompress.downloadAllCheckbox': 'Alle {count} Bilder herunterladen',
  'imageCompress.original': 'Original',
  'imageCompress.compressed': 'Komprimiert',
  // Messages
  'imageCompress.message.compressed': 'Komprimierung erfolgreich!',
  'imageCompress.message.larger': 'Ausgabedatei ist größer. Versuchen Sie, die Qualität zu reduzieren.',
  'imageCompress.message.failed': 'Komprimierung fehlgeschlagen',
  'imageCompress.message.batchSuccess': '{success} Bild(er) erfolgreich komprimiert{failed}',
  'imageCompress.message.batchFailed': 'Alle Komprimierungen fehlgeschlagen',
  'imageCompress.message.noImagesToDownload': 'Keine komprimierten Bilder zum Herunterladen',
  'imageCompress.message.downloading': '{count} Bild(er) werden heruntergeladen...',
  // Preset sizes
  'imageCompress.preset.instagramPost': 'Instagram-Beitrag (1:1)',
  'imageCompress.preset.square': 'Quadrat (1:1)',
  'imageCompress.preset.facebookCover': 'Facebook-Cover (16:9)',
  'imageCompress.preset.twitterHeader': 'Twitter-Header (3:1)',
  'imageCompress.preset.youtubeThumbnail': 'YouTube-Miniaturansicht (16:9)',
  'imageCompress.preset.facebookPost': 'Facebook-Beitrag (1.91:1)',
  'imageCompress.preset.instagramStory': 'Instagram-Story (9:16)',
  'imageCompress.preset.tiktok': 'TikTok (9:16)',
  'imageCompress.preset.4kUHD': '4K UHD (16:9)',
  'imageCompress.preset.2kQHD': '2K QHD (16:9)',
  'imageCompress.preset.fullHD': 'Full HD (16:9)',
  'imageCompress.preset.hd': 'HD (16:9)',
  'imageCompress.preset.landscape16:9': 'Landschaft 16:9',
  'imageCompress.preset.classic4:3': 'Klassisch 4:3',
  'imageCompress.preset.photo3:2': 'Foto 3:2',
  'imageCompress.preset.ultrawide21:9': 'Ultrabreit 21:9',
  'imageCompress.preset.a4Portrait': 'A4 Hochformat (8.27×11.69")',
  'imageCompress.preset.a4Landscape': 'A4 Querformat (11.69×8.27")',
  'imageCompress.preset.letterPortrait': 'Letter Hochformat (8.5×11")',
  // AudioCompress
  'audioCompress.title': 'Professionelles Audio-Kompressionstool',
  'audioCompress.subtitle': 'Browser-basierte Kompression, Datenschutz geschützt',
  'audioCompress.upload': 'Audio hochladen',
  'audioCompress.uploadNew': 'Klicken Sie, um neue Audio hochzuladen',
  'audioCompress.uploadToStart': 'Laden Sie Audio hoch, um die Kompression zu starten',
  'audioCompress.settings': 'Einstellungen',
  'audioCompress.clearAll': 'Alles löschen',
  'audioCompress.totalSavings': 'Speicherplatz gespart',
  'audioCompress.totalSize': 'Gesamtgröße',
  'audioCompress.audioInfo': 'Audio-Info',
  'audioCompress.quality': 'Qualität',
  'audioCompress.bitrate': 'Bitrate',
  'audioCompress.bitrate.320': '320 kbps (Höchste Qualität)',
  'audioCompress.bitrate.256': '256 kbps (Hohe Qualität)',
  'audioCompress.bitrate.192': '192 kbps (Standard-Qualität)',
  'audioCompress.bitrate.128': '128 kbps (Mittlere Qualität)',
  'audioCompress.bitrate.96': '96 kbps (Niedrige Qualität)',
  'audioCompress.bitrate.64': '64 kbps (Niedrigste Qualität)',
  'audioCompress.format': 'Format',
  'audioCompress.format.mp3': 'MP3 (Empfohlen)',
  'audioCompress.format.ogg': 'OGG',
  'audioCompress.format.aac': 'AAC',
  'audioCompress.format.wav': 'WAV',
  'audioCompress.sampleRate': 'Abtastrate',
  'audioCompress.sampleRate.48000': '48000 Hz',
  'audioCompress.sampleRate.44100': '44100 Hz (CD-Qualität)',
  'audioCompress.sampleRate.32000': '32000 Hz',
  'audioCompress.sampleRate.22050': '22050 Hz',
  'audioCompress.sampleRate.16000': '16000 Hz',
  'audioCompress.compress': 'Kompression starten',
  'audioCompress.compressing': 'Komprimieren...',
  'audioCompress.download': 'Audio herunterladen',
  // AudioCompress Messages
  'audioCompress.message.compressed': 'Kompression erfolgreich!',
  'audioCompress.message.failed': 'Kompression fehlgeschlagen, bitte erneut versuchen',
  'audioCompress.message.invalidFile': 'Bitte wählen Sie eine Audiodatei aus!',
  'audioCompress.message.loadError': 'Fehler beim Laden der Audiodatei',

  // Settings
  'settings.title': 'Systemeinstellungen',
  'settings.description': 'Personalisieren Sie Ihre KI-Generierungsplattform',
  'settings.notifications.title': 'Benachrichtigungseinstellungen',
  'settings.notifications.description': 'Verwalten Sie Benachrichtigungen',
  'settings.notifications.email': 'E-Mail-Benachrichtigungen',
  'settings.notifications.emailDesc': 'Wichtige Updates und Aufgaben-E-Mails erhalten',
  'settings.notifications.push': 'Push-Benachrichtigungen',
  'settings.notifications.pushDesc': 'Echtzeit-Push-Nachrichten erhalten',
  'settings.notifications.sound': 'Sound-Hinweise',
  'settings.notifications.soundDesc': 'Sound bei Benachrichtigung abspielen',
  'settings.notifications.volume': 'Benachrichtigungsleitung',
  'settings.notifications.volumeDesc': 'Lautstärke der Benachrichtigungen',
  'settings.notifications.marketing': 'Marketing',
  'settings.notifications.marketingDesc': 'Plattform-Events und Werbung erhalten',
  'settings.interface.title': 'Oberfläche',
  'settings.interface.description': 'Darstellung anpassen',
  'settings.interface.theme': 'Design',
  'settings.interface.themeDesc': 'Theme wählen',
  'settings.interface.language': 'Sprache',
  'settings.interface.languageDesc': 'Anzeigesprache wählen',
  'settings.interface.animation': 'Animationen',
  'settings.interface.animationDesc': 'Übergangsanimationen aktivieren',
  'settings.interface.tips': 'Tipps für Einsteiger',
  'settings.interface.tipsDesc': 'Hinweise und Anleitungen anzeigen',
  'settings.theme.light': 'Hell',
  'settings.theme.dark': 'Dunkel',
  'settings.theme.auto': 'Automatisch',
  'settings.ai.title': 'KI-Generierung',
  'settings.ai.description': 'Qualität und Leistung optimieren',
  'settings.ai.autoOptimize': 'Intelligente Optimierung',
  'settings.ai.autoOptimizeDesc': 'KI optimiert Parameter automatisch',
  'settings.ai.quality': 'Generierungsqualität',
  'settings.ai.qualityDesc': 'Balance aus Geschwindigkeit und Qualität',
  'settings.ai.cloudSync': 'Cloud-Sync',
  'settings.ai.cloudSyncDesc': 'Werke automatisch in die Cloud synchronisieren',
  'settings.ai.autoSave': 'Auto-Speichern',
  'settings.ai.autoSaveDesc': 'Ergebnisse nach Generierung automatisch speichern',
  'settings.ai.safetyFilter': 'Sicherheitsfilter',
  'settings.ai.safetyFilterDesc': 'Unangemessene Inhalte filtern',
  'settings.ai.watermark': 'Wasserzeichen',
  'settings.ai.watermarkDesc': 'Wasserzeichen automatisch hinzufügen',
  'settings.ai.promptSuggestions': 'Eingabe-Vorschläge',
  'settings.ai.promptSuggestionsDesc': 'Vorschläge zur Optimierung',
  'settings.quality.fast': 'Schnell',
  'settings.quality.balanced': 'Ausgewogen',
  'settings.quality.high': 'Hohe Qualität',
  'settings.privacy.title': 'Datenschutz & Sicherheit',
  'settings.privacy.description': 'Persönliche Daten schützen',
  'settings.privacy.profile': 'Profil-Sichtbarkeit',
  'settings.privacy.profileDesc': 'Profil für andere sichtbar',
  'settings.privacy.activity': 'Aktivitätsstatus anzeigen',
  'settings.privacy.activityDesc': 'Online-Status für Freunde sichtbar',
  'settings.privacy.analytics': 'Analyse-Daten',
  'settings.privacy.analyticsDesc': 'Produkt verbessern helfen',
  'settings.privacy.showWorks': 'Werke-Sichtbarkeit',
  'settings.privacy.showWorksDesc': 'Werke für andere sichtbar',
  'settings.privacy.allowComments': 'Kommentare erlauben',
  'settings.privacy.allowCommentsDesc': 'Andere dürfen kommentieren',
  'settings.privacy.allowDownload': 'Download erlauben',
  'settings.privacy.allowDownloadDesc': 'Andere dürfen herunterladen',
  'settings.performance.title': 'Leistung',
  'settings.performance.description': 'Systemleistung anpassen',
  'settings.performance.hardware': 'Hardware-Beschleunigung',
  'settings.performance.hardwareDesc': 'GPU-Beschleunigung nutzen',
  'settings.performance.preview': 'Vorschau-Qualität',
  'settings.performance.previewDesc': 'Qualitätsstufe der Vorschau',
  'settings.performance.autoClean': 'Cache automatisch leeren',
  'settings.performance.autoCleanDesc': 'Temporäre Dateien regelmäßig löschen',
  'settings.performance.imageCompression': 'Bildkompression',
  'settings.performance.imageCompressionDesc': 'Hochgeladene Bilder komprimieren',
  'settings.performance.lazyLoading': 'Lazy Loading',
  'settings.performance.lazyLoadingDesc': 'Seiteninhalte verzögert laden',
  'settings.preview.low': 'Niedrig',
  'settings.preview.medium': 'Mittel',
  'settings.preview.high': 'Hoch',
  'settings.workflow.title': 'Workflow',
  'settings.workflow.description': 'KI-Workflow anpassen',
  'settings.workflow.resolution': 'Standardauflösung',
  'settings.workflow.resolutionDesc': 'Standardgröße für Bildgenerierung',
  'settings.workflow.saveHistory': 'Verlauf speichern',
  'settings.workflow.saveHistoryDesc': 'Parameter und Prompts speichern',
  'settings.workflow.autoTag': 'Smart Tags',
  'settings.workflow.autoTagDesc': 'Automatisch Tags hinzufügen',
  'settings.workflow.template': 'Vorlagen',
  'settings.workflow.templateDesc': 'Workflow-Vorlagen aktivieren',
  'settings.file.title': 'Dateiverwaltung',
  'settings.file.description': 'Speicher und Backup verwalten',
  'settings.file.autoBackup': 'Automatisches Backup',
  'settings.file.autoBackupDesc': 'Wichtige Dateien sichern',
  'settings.file.backupFrequency': 'Backup-Häufigkeit',
  'settings.file.backupFrequencyDesc': 'Häufigkeit wählen',
  'settings.file.realtime': 'Echtzeit',
  'settings.file.daily': 'Täglich',
  'settings.file.weekly': 'Wöchentlich',
  'settings.file.autoOrganize': 'Automatisch sortieren',
  'settings.file.autoOrganizeDesc': 'Dateien automatisch kategorisieren',
  'settings.file.defaultFormat': 'Standardformat',
  'settings.file.defaultFormatDesc': 'Standardformat beim Speichern',
  'settings.social.title': 'Soziales',
  'settings.social.description': 'Soziale Funktionen verwalten',
  'settings.social.allowFollow': 'Folgen erlauben',
  'settings.social.allowFollowDesc': 'Andere dürfen folgen',
  'settings.social.allowMessage': 'Nachrichten erlauben',
  'settings.social.allowMessageDesc': 'Andere dürfen schreiben',
  'settings.social.likeNotify': 'Like-Benachrichtigungen',
  'settings.social.likeNotifyDesc': 'Benachrichtigung bei Likes',
  'settings.social.mentionNotify': 'Erwähnungs-Benachrichtigungen',
  'settings.social.mentionNotifyDesc': 'Benachrichtigung bei Erwähnung',
  'settings.security.title': 'Kontosicherheit',
  'settings.security.description': 'Sicherheit stärken',
  'settings.security.twoFactor': 'Zwei-Faktor-Authentifizierung',
  'settings.security.twoFactorDesc': 'Zusätzliche Sicherheitsstufe',
  'settings.security.loginNotify': 'Anmelde-Benachrichtigungen',
  'settings.security.loginNotifyDesc': 'Bei Anmeldung von neuem Gerät',
  'settings.security.deviceVerify': 'Geräteprüfung',
  'settings.security.deviceVerifyDesc': 'Unbekannte Geräte prüfen',
  'settings.security.autoLogout': 'Auto-Abmelden bei Inaktivität',
  'settings.security.autoLogoutDesc': 'Bei langer Inaktivität abmelden',
  'settings.button.save': 'Speichern',
  'settings.button.reset': 'Zurücksetzen',
  'settings.badge.on': 'An',
  'settings.badge.recommended': 'Empfohlen',
  'settings.message.saveSuccess': 'Einstellungen gespeichert',
  'settings.message.autoSaved': 'Einstellungen automatisch gespeichert',
  'settings.message.saveFailed': 'Speichern fehlgeschlagen',
  'settings.message.resetSuccess': 'Auf Standard zurückgesetzt',
  'settings.autoSaveHint': 'Einstellungen werden automatisch gespeichert',
  'settings.confirm.resetTitle': 'Zurücksetzen bestätigen',
  'settings.confirm.resetContent': 'Alle Einstellungen auf Standard zurücksetzen?',
  'settings.confirm.reset': 'Zurücksetzen',
  'settings.confirm.cancel': 'Abbrechen',

  // Prompt Version History
  'prompt.version.label.prompt': 'Eingabeaufforderung',
  'prompt.version.label.negativePrompt': 'Negative Eingabeaufforderung',
  'prompt.version.label.result': 'Ergebnis',
}; 